var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGrowyourBusinesssection(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 553.111,
    height: 372.469,
    viewBox: "0 0 553.111 372.469",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.047,
    y1: 1.014,
    x2: 0.988,
    y2: 0.024,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4b6cb7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#134270"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.922,
    y1: -0.287,
    x2: -0.361,
    y2: 2.167,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d6e9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#134270"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.879,
    y1: -1.654,
    x2: -0.011,
    y2: 3.402,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2b3582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#150e42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 1158.835,
    y1: 0.23,
    x2: 1078.042,
    y2: 1.744,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 1137.638,
    y1: 0.119,
    x2: 1056.844,
    y2: 1.633,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 40.494,
    y1: 0.5,
    x2: 41.494,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cfffb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9bfffa"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 41.683,
    y1: 0.5,
    x2: 42.683,
    y2: 0.5,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 45.191,
    y1: 0.5,
    x2: 46.191,
    y2: 0.5,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 65.883,
    y1: 0.5,
    x2: 66.883,
    y2: 0.5,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 69.428,
    y1: 0.5,
    x2: 70.428,
    y2: 0.5,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 68.834,
    y1: 0.5,
    x2: 69.834,
    y2: 0.5,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 64.161,
    y1: 0.5,
    x2: 65.161,
    y2: 0.5,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 63.594,
    y1: 0.5,
    x2: 64.594,
    y2: 0.5,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 17.579,
    y1: 2.381,
    x2: 19.103,
    y2: 5.069,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#134270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.163,
    stopColor: "#4b6cb7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#4b6cb7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#12355f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 0.489,
    y1: 0.119,
    x2: 0.5,
    y2: 1.09,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4b6cb7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#182848"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 1.063,
    y1: -0.44,
    x2: 0.221,
    y2: 0.966,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#134270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.072,
    stopColor: "#4b6cb7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#12355f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 0.446,
    y1: 0.546,
    x2: 1.218,
    y2: -0.175,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 0.922,
    y1: 0.113,
    x2: -0.661,
    y2: 1.718,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 0.04,
    y1: 1.594,
    x2: 0.638,
    y2: 0.173,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#134270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.072,
    stopColor: "#4b6cb7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#182848"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 1525.74,
    y1: 0.954,
    x2: 1527.991,
    y2: -0.303,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cb236d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4c246d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 174.742,
    y1: 0.099,
    x2: 174.997,
    y2: -20.584,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 111.393,
    y1: 4.039,
    x2: 111.589,
    y2: -0.315,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd3a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f48a21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 23.708,
    y1: 10.511,
    x2: 23.299,
    y2: 11.629,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 63.16,
    y1: 17.855,
    x2: 64.288,
    y2: 17.855,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9b776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 9.592,
    y1: 3.618,
    x2: 10.284,
    y2: 2.707,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#125082"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.231,
    stopColor: "#242a70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.728,
    stopColor: "#19154e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#150e42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 20.516,
    y1: 15.032,
    x2: 19.275,
    y2: 18.504,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 19.34,
    y1: 24.909,
    x2: 20.273,
    y2: 24.909,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#53d8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3840f7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 53.686,
    y1: 18.777,
    x2: 54.588,
    y2: 18.777,
    xlinkHref: "#linear-gradient-24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 7.935,
    y1: 3.302,
    x2: 7.965,
    y2: 2.324,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#125082"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#125082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 0.322,
    y1: 0.194,
    x2: 1,
    y2: 0.908,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f48a21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.072,
    stopColor: "#f48a21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#125082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 17.599,
    y1: 9.745,
    x2: 18.592,
    y2: 9.745,
    xlinkHref: "#linear-gradient-24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 0.686,
    y1: -0.217,
    x2: 0.267,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f48a21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.363,
    stopColor: "#f48a21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#125082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 30.472,
    y1: 9.997,
    x2: 31.591,
    y2: 9.997,
    xlinkHref: "#linear-gradient-24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 0.928,
    y1: 0.172,
    x2: 0.168,
    y2: 0.977,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f48a21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#125082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 15.231,
    y1: -5.189,
    x2: 13.987,
    y2: 1.627,
    xlinkHref: "#linear-gradient-24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 428.168,
    y1: 0.175,
    x2: 426.852,
    y2: 1.493,
    xlinkHref: "#linear-gradient-24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: -35.187,
    y1: -0.149,
    x2: -35.652,
    y2: 1.601,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 1436.797,
    y1: 2.7,
    x2: 1440.247,
    y2: 0.456,
    xlinkHref: "#linear-gradient-24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 126.742,
    y1: 94.185,
    x2: 126.002,
    y2: 96.622,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 96.303,
    y1: 0.134,
    x2: 95.903,
    y2: 0.8,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 967.382,
    y1: -0.304,
    x2: 965.543,
    y2: 1.583,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f48a21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f48a21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 141.214,
    y1: 0.5,
    x2: 142.214,
    y2: 0.5,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 141.446,
    y1: 0.5,
    x2: 142.446,
    y2: 0.5,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 146.867,
    y1: 0.5,
    x2: 147.867,
    y2: 0.5,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 147.098,
    y1: 0.5,
    x2: 148.098,
    y2: 0.5,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: 33.947,
    y1: 0.5,
    x2: 34.947,
    y2: 0.5,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: 0.304,
    y1: 0.072,
    x2: 1.473,
    y2: 3.84,
    xlinkHref: "#linear-gradient-24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: -0.316,
    y1: 1.308,
    x2: 0.3,
    y2: 0.687,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f48a21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#125082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: 184.711,
    y1: 0.5,
    x2: 185.73,
    y2: 0.5,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: 181.314,
    y1: 0.5,
    x2: 182.314,
    y2: 0.5,
    xlinkHref: "#linear-gradient-27"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: 378.58,
    y1: 0.5,
    x2: 379.58,
    y2: 0.5,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: 390.134,
    y1: 0.5,
    x2: 391.134,
    y2: 0.5,
    xlinkHref: "#linear-gradient-27"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: 584.274,
    y1: 0.5,
    x2: 585.274,
    y2: 0.5,
    xlinkHref: "#linear-gradient-24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: 713.48,
    y1: 0.5,
    x2: 714.48,
    y2: 0.5,
    xlinkHref: "#linear-gradient-24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: 0.492,
    y1: 0.809,
    x2: 0.525,
    y2: -0.418,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#125082"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#150e42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: 1003.009,
    y1: -3.525,
    x2: 997.272,
    y2: 3.756,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: -0.05,
    y1: -0.04,
    x2: 0.884,
    y2: 0.738,
    xlinkHref: "#linear-gradient-48"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: 343.828,
    y1: 1.331,
    x2: 344.064,
    y2: 0.355,
    xlinkHref: "#linear-gradient-24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: 251.989,
    y1: 0.35,
    x2: 250.877,
    y2: 1.106,
    xlinkHref: "#linear-gradient-24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: 181.901,
    y1: 0.154,
    x2: 182.63,
    y2: 1.105,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: 1027.459,
    y1: -0.685,
    x2: 1022.909,
    y2: 1.784,
    xlinkHref: "#linear-gradient-24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: 11.387,
    y1: -33.08,
    x2: 12.091,
    y2: -31.458,
    xlinkHref: "#linear-gradient-29"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: 11.951,
    y1: -31.428,
    x2: 12.456,
    y2: -29.828,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#134270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4b6cb7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: 0.008,
    y1: 0.097,
    x2: 1.026,
    y2: 0.839,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4b6cb7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453,
    stopColor: "#125082"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.791,
    stopColor: "#125082"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4b6cb7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: 0.256,
    y1: 0.268,
    x2: 2.785,
    y2: 2.005,
    xlinkHref: "#linear-gradient-24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: -0.511,
    y1: -0.453,
    x2: 0.809,
    y2: 0.995,
    xlinkHref: "#linear-gradient-48"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    x1: 0.127,
    y1: -0.777,
    x2: 2.098,
    y2: 6.835,
    xlinkHref: "#linear-gradient-24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: -0.356,
    y1: -0.364,
    x2: 2.175,
    y2: 2.061,
    xlinkHref: "#linear-gradient-24"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grow_your_Business_section",
    "data-name": "Grow your Business section",
    transform: "translate(-89.689 -105.257)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10656",
    "data-name": "Group 10656",
    transform: "translate(114.158 174.479)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10654",
    "data-name": "Group 10654",
    transform: "translate(23.554 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2889",
    "data-name": "Path 2889",
    d: "M642.712,508.6a8.312,8.312,0,0,1-8.292,8.284h-448.4a8.313,8.313,0,0,1-8.292-8.284L174,250.914c0-4.556,5.368-13.451,15.205-12.783l438.224-11.339a20.9,20.9,0,0,1,21.441,21.372Z",
    transform: "translate(-174 -226.786)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2890",
    "data-name": "Path 2890",
    d: "M643.194,508.073a7.868,7.868,0,0,1-7.845,7.845H205.5a7.868,7.868,0,0,1-7.844-7.845l-3.521-233.925c.415-14.077,12.757-19.137,20.238-18.838l420-11.268A14.686,14.686,0,0,1,649.44,259.07Z",
    transform: "translate(-182.668 -234.211)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10653",
    "data-name": "Group 10653",
    transform: "translate(17.318 22.543)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2891",
    "data-name": "Path 2891",
    d: "M207.834,496.268a.57.57,0,0,1-.569-.561l-.279-18.971a.57.57,0,0,1,.562-.578.584.584,0,0,1,.578.562l.279,18.97a.571.571,0,0,1-.562.578Z",
    transform: "translate(-205.515 -356.66)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2892",
    "data-name": "Path 2892",
    d: "M206.04,359.483a.57.57,0,0,1-.569-.562L204.4,286.262c.022-4.833,1.51-8.694,4.423-11.485,5.3-5.083,13.608-4.823,13.961-4.814l134.129-3.6h.015a.57.57,0,0,1,.015,1.139l-134.161,3.6c-.372-.017-8.211-.256-13.171,4.5-2.682,2.57-4.053,6.156-4.073,10.658L206.61,358.9a.57.57,0,0,1-.562.578Z",
    transform: "translate(-204.404 -266.363)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2893",
    "data-name": "Path 2893",
    d: "M232.913,508.378c.45-19.334.282-190.544-.827-205.33s21.92-17.559,57.276-19.224,333.672-8.252,341.353-8.875c17.265-1.4,20.839,24.406,19.111,80.429-1.3,42.09-3.448,111.425-4.438,143.31a17.6,17.6,0,0,1-17.553,17.053c-71.787.2-346.925.985-365.241,1.531C241.516,517.9,232.735,516.045,232.913,508.378Z",
    transform: "translate(-198.984 -247.492)",
    fill: "#fff",
    opacity: 0.37
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1615",
    "data-name": "Rectangle 1615",
    width: 528.643,
    height: 22.641,
    rx: 7.505,
    transform: "translate(0 280.606)",
    fill: "url(#linear-gradient-3)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10657",
    "data-name": "Group 10657",
    transform: "translate(481.603 330.989)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2894",
    "data-name": "Path 2894",
    d: "M783.049,648.04a1.193,1.193,0,0,0,1.193-1.193V504.259a1.193,1.193,0,0,0-2.386,0V646.848A1.193,1.193,0,0,0,783.049,648.04Z",
    transform: "translate(-779.516 -502.208)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2895",
    "data-name": "Path 2895",
    d: "M839.8,648.04A1.193,1.193,0,0,0,841,646.848V504.259a1.193,1.193,0,0,0-2.386,0V646.848A1.193,1.193,0,0,0,839.8,648.04Z",
    transform: "translate(-803.943 -502.208)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2896",
    "data-name": "Path 2896",
    d: "M933.148,648.945a1.194,1.194,0,0,0,1.1-1.66l-61-143.493a1.193,1.193,0,0,0-2.2.934l61,143.492A1.193,1.193,0,0,0,933.148,648.945Z",
    transform: "translate(-817.863 -502.208)",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2897",
    "data-name": "Path 2897",
    d: "M866.995,648.945a1.194,1.194,0,0,0,1.1-1.66l-61-143.493a1.193,1.193,0,0,0-2.2.934l61,143.492A1.194,1.194,0,0,0,866.995,648.945Z",
    transform: "translate(-789.39 -502.208)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1628",
    "data-name": "Rectangle 1628",
    width: 59.242,
    height: 3.363,
    rx: 1.681,
    transform: "translate(59.242 3.363) rotate(180)",
    fill: "url(#linear-gradient-8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2898",
    "data-name": "Path 2898",
    d: "M822.172,543.972h37.792a1.193,1.193,0,0,0,0-2.386H822.172a1.193,1.193,0,0,0,0,2.386Z",
    transform: "translate(-796.354 -518.788)",
    fill: "url(#linear-gradient-9)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1629",
    "data-name": "Rectangle 1629",
    width: 37.792,
    height: 2.386,
    transform: "translate(37.413 49.937)",
    fill: "url(#linear-gradient-10)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1630",
    "data-name": "Rectangle 1630",
    width: 37.792,
    height: 2.386,
    transform: "translate(48.639 77.075)",
    fill: "url(#linear-gradient-11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2899",
    "data-name": "Path 2899",
    d: "M882.907,686.906H920.7a1.193,1.193,0,0,0,0-2.386H882.907a1.193,1.193,0,0,0,0,2.386Z",
    transform: "translate(-822.495 -580.307)",
    fill: "url(#linear-gradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2900",
    "data-name": "Path 2900",
    d: "M902.889,734.552h37.792a1.193,1.193,0,0,0,0-2.386H902.889a1.193,1.193,0,0,0,0,2.386Z",
    transform: "translate(-831.095 -600.814)",
    fill: "url(#linear-gradient-13)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10661",
    "data-name": "Group 10661",
    transform: "translate(253.59 188.157)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10658",
    "data-name": "Group 10658",
    transform: "translate(0 0)",
    opacity: 0.64
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2901",
    "data-name": "Path 2901",
    d: "M384.163,435.515a1.425,1.425,0,0,1-1.366-1.024q-.325-1.109-.621-2.232a1.424,1.424,0,0,1,2.754-.725q.285,1.083.6,2.156a1.425,1.425,0,0,1-.965,1.767A1.444,1.444,0,0,1,384.163,435.515Z",
    transform: "translate(-379.458 -328.132)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2902",
    "data-name": "Path 2902",
    d: "M379.994,348.843a1.424,1.424,0,0,1-1.4-1.188c-.252-1.5-.466-3.024-.635-4.534a1.424,1.424,0,1,1,2.83-.317c.164,1.459.37,2.932.614,4.378a1.425,1.425,0,0,1-1.406,1.66Zm-1.111-11.751a1.424,1.424,0,0,1-1.423-1.393q-.02-.912-.021-1.827c0-.913.015-1.838.046-2.751a1.424,1.424,0,1,1,2.846.094c-.029.881-.044,1.775-.044,2.657q0,.884.02,1.765a1.424,1.424,0,0,1-1.393,1.455Zm.588-11.787a1.39,1.39,0,0,1-.174-.011,1.424,1.424,0,0,1-1.242-1.585c.183-1.509.411-3.032.676-4.526a1.424,1.424,0,1,1,2.8.5c-.256,1.444-.476,2.915-.653,4.372A1.425,1.425,0,0,1,379.471,325.306Zm2.262-11.58a1.427,1.427,0,0,1-1.375-1.8c.4-1.465.843-2.94,1.323-4.382a1.424,1.424,0,0,1,2.7.9c-.463,1.393-.893,2.816-1.277,4.231A1.425,1.425,0,0,1,381.733,313.725Zm3.915-11.131a1.425,1.425,0,0,1-1.3-1.994c.608-1.394,1.264-2.79,1.949-4.15a1.424,1.424,0,0,1,2.543,1.282c-.662,1.313-1.295,2.661-1.882,4.007A1.424,1.424,0,0,1,385.648,302.594Zm5.5-10.452a1.424,1.424,0,0,1-1.208-2.177c.8-1.289,1.654-2.575,2.529-3.821a1.424,1.424,0,0,1,2.331,1.638c-.845,1.2-1.667,2.445-2.442,3.689A1.422,1.422,0,0,1,391.146,292.143ZM398.1,282.6a1.424,1.424,0,0,1-1.086-2.343c.983-1.162,2.009-2.311,3.051-3.415a1.424,1.424,0,0,1,2.07,1.956c-1.006,1.065-2,2.175-2.947,3.3A1.42,1.42,0,0,1,398.1,282.6Zm8.252-8.441a1.424,1.424,0,0,1-.945-2.49c1.136-1.007,2.316-2,3.508-2.94a1.424,1.424,0,1,1,1.769,2.232c-1.151.913-2.292,1.868-3.388,2.84A1.421,1.421,0,0,1,406.349,274.159Zm9.375-7.169a1.424,1.424,0,0,1-.783-2.614c1.272-.835,2.582-1.644,3.892-2.4a1.424,1.424,0,1,1,1.43,2.463c-1.266.734-2.53,1.516-3.759,2.322A1.417,1.417,0,0,1,415.724,266.99Zm83-3.814a1.407,1.407,0,0,1-.668-.168c-1.291-.688-2.623-1.349-3.958-1.968a1.424,1.424,0,1,1,1.2-2.584c1.383.64,2.763,1.327,4.1,2.039a1.424,1.424,0,0,1-.67,2.681Zm-72.692-1.93a1.424,1.424,0,0,1-.6-2.715c1.379-.643,2.791-1.254,4.2-1.817a1.424,1.424,0,0,1,1.059,2.644c-1.357.543-2.719,1.133-4.051,1.754A1.414,1.414,0,0,1,426.028,261.246Zm61.9-2.842a1.419,1.419,0,0,1-.48-.084c-1.377-.492-2.791-.954-4.2-1.371a1.424,1.424,0,0,1,.808-2.731c1.463.433,2.927.91,4.354,1.421a1.424,1.424,0,0,1-.48,2.765Zm-50.876-1.353a1.424,1.424,0,0,1-.408-2.788c1.458-.437,2.945-.837,4.421-1.191a1.424,1.424,0,0,1,.664,2.77c-1.424.341-2.859.728-4.267,1.149A1.413,1.413,0,0,1,437.049,257.051Zm39.5-1.8a1.431,1.431,0,0,1-.281-.028c-1.434-.288-2.9-.539-4.359-.749a1.424,1.424,0,0,1,.406-2.819c1.509.217,3.027.478,4.512.775a1.424,1.424,0,0,1-.278,2.821Zm-27.983-.75a1.424,1.424,0,0,1-.2-2.833c1.506-.22,3.036-.4,4.547-.535a1.424,1.424,0,1,1,.254,2.837c-1.458.13-2.935.3-4.389.516A1.425,1.425,0,0,1,448.569,254.5Zm16.269-.73-.078,0c-1.42-.077-2.854-.117-4.268-.12h-.154a1.424,1.424,0,0,1-.328-2.81l.135-.038h.2c1.512,0,3.049.042,4.569.125a1.424,1.424,0,0,1-.076,2.846Z",
    transform: "translate(-377.44 -250.8)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2903",
    "data-name": "Path 2903",
    d: "M602.3,278.234a1.417,1.417,0,0,1-.812-.256q-.918-.638-1.854-1.251a1.424,1.424,0,1,1,1.56-2.383q.971.635,1.921,1.3a1.424,1.424,0,0,1-.815,2.593Z",
    transform: "translate(-472.795 -260.834)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10659",
    "data-name": "Group 10659",
    transform: "translate(31.998 65.29)",
    opacity: 0.64
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2904",
    "data-name": "Path 2904",
    d: "M662.831,370.512a1.424,1.424,0,0,1-1.4-1.18q-.192-1.1-.415-2.2a1.424,1.424,0,0,1,2.791-.566q.23,1.133.429,2.277a1.423,1.423,0,0,1-1.159,1.647A1.386,1.386,0,0,1,662.831,370.512Z",
    transform: "translate(-531.478 -365.426)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2905",
    "data-name": "Path 2905",
    d: "M493.326,473.152a1.424,1.424,0,0,1-.045-2.847c1.443-.047,2.9-.134,4.342-.259a1.424,1.424,0,1,1,.247,2.837c-1.489.129-3,.22-4.5.269Zm-7.192-.08-.079,0q-.608-.033-1.218-.075c-1.092-.076-2.193-.173-3.273-.29a1.424,1.424,0,0,1,.307-2.831c1.043.113,2.107.208,3.163.281q.59.04,1.176.072a1.424,1.424,0,0,1-.076,2.846Zm18.741-1.126a1.424,1.424,0,0,1-.247-2.826c1.424-.252,2.857-.547,4.26-.876a1.424,1.424,0,1,1,.65,2.772c-1.453.341-2.937.647-4.413.909A1.5,1.5,0,0,1,504.875,471.946Zm-30.268-.322a1.449,1.449,0,0,1-.279-.027c-1.472-.292-2.951-.627-4.395-1a1.424,1.424,0,1,1,.7-2.759c1.395.356,2.823.68,4.245.961a1.424,1.424,0,0,1-.275,2.821Zm41.526-2.52a1.424,1.424,0,0,1-.447-2.777c1.368-.452,2.742-.948,4.085-1.474a1.424,1.424,0,1,1,1.039,2.651c-1.39.545-2.813,1.059-4.23,1.528A1.419,1.419,0,0,1,516.133,469.1Zm-52.734-.547a1.406,1.406,0,0,1-.473-.082c-1.413-.5-2.829-1.041-4.208-1.614a1.424,1.424,0,1,1,1.093-2.63c1.331.554,2.7,1.078,4.062,1.558a1.424,1.424,0,0,1-.473,2.768Zm63.466-3.873a1.424,1.424,0,0,1-.636-2.7c1.293-.645,2.584-1.332,3.837-2.043a1.424,1.424,0,1,1,1.406,2.476c-1.3.736-2.633,1.448-3.972,2.115A1.412,1.412,0,0,1,526.865,464.684Zm-74.117-.765a1.425,1.425,0,0,1-.66-.163c-1.321-.693-2.645-1.433-3.933-2.2a1.424,1.424,0,1,1,1.456-2.448c1.244.74,2.522,1.455,3.8,2.123a1.424,1.424,0,0,1-.662,2.686Zm84.115-5.137a1.424,1.424,0,0,1-.81-2.6c1.188-.82,2.369-1.684,3.511-2.567a1.424,1.424,0,1,1,1.742,2.253c-1.182.914-2.4,1.809-3.635,2.658A1.418,1.418,0,0,1,536.863,458.782Zm9.064-7.258a1.424,1.424,0,0,1-.966-2.469c1.059-.979,2.107-2,3.115-3.039A1.424,1.424,0,1,1,550.119,448c-1.043,1.074-2.128,2.132-3.225,3.145A1.416,1.416,0,0,1,545.927,451.524Zm7.951-8.466a1.424,1.424,0,0,1-1.1-2.322c.913-1.122,1.806-2.283,2.655-3.451a1.424,1.424,0,0,1,2.3,1.676c-.88,1.209-1.8,2.41-2.749,3.572A1.42,1.42,0,0,1,553.878,443.058Zm6.672-9.51a1.408,1.408,0,0,1-.731-.2,1.424,1.424,0,0,1-.489-1.953c.744-1.241,1.464-2.517,2.138-3.794a1.424,1.424,0,1,1,2.519,1.329c-.7,1.323-1.444,2.645-2.215,3.93A1.424,1.424,0,0,1,560.55,433.547Zm5.251-10.367a1.426,1.426,0,0,1-1.313-1.975c.558-1.331,1.087-2.695,1.571-4.055a1.424,1.424,0,0,1,2.683.956c-.5,1.409-1.05,2.822-1.628,4.2A1.424,1.424,0,0,1,565.8,423.181Zm3.711-11a1.426,1.426,0,0,1-1.379-1.781c.362-1.4.69-2.823.976-4.238a1.424,1.424,0,0,1,2.792.563c-.3,1.466-.636,2.943-1.011,4.389A1.425,1.425,0,0,1,569.512,412.176Zm2.1-11.419a1.36,1.36,0,0,1-.159-.009,1.424,1.424,0,0,1-1.257-1.574c.127-1.137.232-2.293.311-3.438.02-.3.039-.6.057-.9a1.424,1.424,0,1,1,2.843.167q-.026.462-.059.926c-.082,1.187-.19,2.383-.322,3.561A1.424,1.424,0,0,1,571.617,400.757Zm.477-11.6a1.425,1.425,0,0,1-1.423-1.383c-.042-1.442-.124-2.9-.244-4.344a1.424,1.424,0,0,1,2.838-.237c.124,1.491.21,3,.253,4.5a1.424,1.424,0,0,1-1.382,1.465Z",
    transform: "translate(-439.574 -372.509)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2906",
    "data-name": "Path 2906",
    d: "M436.865,511.94a1.418,1.418,0,0,1-.833-.27q-.939-.678-1.857-1.383a1.424,1.424,0,1,1,1.732-2.261q.888.679,1.8,1.336a1.424,1.424,0,0,1-.836,2.577Z",
    transform: "translate(-433.616 -426.675)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10660",
    "data-name": "Group 10660",
    transform: "translate(19.889 19.191)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2907",
    "data-name": "Path 2907",
    d: "M431.414,392.855a.978.978,0,0,0,1.1.3l11.182-4.112a51.908,51.908,0,0,0,14.8,7.973l2.727,11.59a.979.979,0,0,0,.854.75L476.3,410.8a.98.98,0,0,0,.987-.563l5-10.807a51.907,51.907,0,0,0,16.1-4.842l10.131,6.271a.98.98,0,0,0,1.134-.074l11.072-9.035a.98.98,0,0,0,.3-1.1l-4.113-11.182a51.885,51.885,0,0,0,7.973-14.8l11.591-2.727a.979.979,0,0,0,.75-.854l1.441-14.219a.979.979,0,0,0-.563-.987l-10.808-5a51.9,51.9,0,0,0-4.842-16.1l6.271-10.131a.979.979,0,0,0-.073-1.134l-9.036-11.072a.978.978,0,0,0-1.1-.3l-11.182,4.112a51.911,51.911,0,0,0-14.8-7.973l-2.727-11.59a.979.979,0,0,0-.854-.75l-14.219-1.44a.978.978,0,0,0-.987.563l-5,10.807a51.894,51.894,0,0,0-16.1,4.842l-10.131-6.271a.978.978,0,0,0-1.134.074L430.3,303.548a.98.98,0,0,0-.3,1.1l4.112,11.182a51.883,51.883,0,0,0-7.973,14.8l-11.591,2.727a.98.98,0,0,0-.75.854l-1.44,14.218a.979.979,0,0,0,.563.988l10.808,5a51.9,51.9,0,0,0,4.842,16.1l-6.271,10.13a.979.979,0,0,0,.074,1.135Z",
    transform: "translate(-412.358 -284.492)",
    fill: "url(#linear-gradient-14)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2908",
    "data-name": "Path 2908",
    d: "M512.774,398.748a13.835,13.835,0,1,1,2.025-.149A13.85,13.85,0,0,1,512.774,398.748Zm.017-25.382a11.551,11.551,0,1,0,1.676,22.979,11.551,11.551,0,0,0-1.676-22.979Z",
    transform: "translate(-449.629 -321.764)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2909",
    "data-name": "Path 2909",
    d: "M497.155,403.564a35.215,35.215,0,0,1-3.559-.18h0a35.316,35.316,0,0,1-7.3-1.532.57.57,0,0,1-.395-.541.557.557,0,0,1,.029-.176.569.569,0,0,1,.717-.366,33.948,33.948,0,0,0,44.228-28.843,34.656,34.656,0,0,0,.177-3.486,33.917,33.917,0,0,0-67.66-3.35,33.916,33.916,0,0,0,3.027,17.811.554.554,0,0,1,.054.242.569.569,0,0,1-1.085.242,35.057,35.057,0,1,1,66.8-14.946,35.814,35.814,0,0,1-.182,3.6A35.106,35.106,0,0,1,497.155,403.564Z",
    transform: "translate(-433.756 -305.564)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10665",
    "data-name": "Group 10665",
    transform: "translate(398.645 128.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2910",
    "data-name": "Path 2910",
    d: "M661.36,223.765l6.063-2.793a29.093,29.093,0,0,0,8.623,3.8l2.038,6.352a.549.549,0,0,0,.51.381l8.005.173a.551.551,0,0,0,.527-.359l2.31-6.258a29.084,29.084,0,0,0,8.779-3.419l5.937,3.052a.548.548,0,0,0,.63-.092l5.783-5.538a.548.548,0,0,0,.119-.625l-2.793-6.063a29.078,29.078,0,0,0,3.8-8.622l6.353-2.038a.549.549,0,0,0,.38-.51l.173-8.006a.548.548,0,0,0-.358-.526l-6.259-2.31a29.059,29.059,0,0,0-3.419-8.779l3.053-5.937a.549.549,0,0,0-.092-.63l-5.539-5.783a.548.548,0,0,0-.625-.119L699.29,171.9a29.087,29.087,0,0,0-8.623-3.8l-2.038-6.352a.548.548,0,0,0-.51-.381l-8.005-.173a.547.547,0,0,0-.526.358l-2.311,6.258a29.075,29.075,0,0,0-8.778,3.42l-5.937-3.053a.548.548,0,0,0-.63.092l-5.783,5.538a.549.549,0,0,0-.119.625l2.793,6.063a29.088,29.088,0,0,0-3.8,8.623l-6.353,2.037a.549.549,0,0,0-.381.511l-.173,8.005a.548.548,0,0,0,.358.526l6.259,2.311a29.092,29.092,0,0,0,3.419,8.779l-3.052,5.936a.549.549,0,0,0,.091.631l5.539,5.783A.549.549,0,0,0,661.36,223.765Z",
    transform: "translate(-638.998 -152.08)",
    fill: "url(#linear-gradient-15)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2911",
    "data-name": "Path 2911",
    d: "M704.164,224.943a7.691,7.691,0,1,1,1.733-.2h0A7.747,7.747,0,0,1,704.164,224.943Zm1.606-.752h0Zm-1.591-13.471a6.541,6.541,0,1,0,1.464,12.916h0a6.541,6.541,0,0,0-1.464-12.916Z",
    transform: "translate(-659.82 -172.902)",
    fill: "#fff",
    opacity: 0.56
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10664",
    "data-name": "Group 10664"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10662",
    "data-name": "Group 10662",
    opacity: 0.64
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2912",
    "data-name": "Path 2912",
    d: "M644.955,263.267a1.424,1.424,0,0,1-1.192-.644c-.426-.65-.842-1.323-1.237-2a1.424,1.424,0,0,1,2.461-1.433c.369.634.759,1.264,1.157,1.873a1.424,1.424,0,0,1-1.19,2.2Z",
    transform: "translate(-636.506 -193.949)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2913",
    "data-name": "Path 2913",
    d: "M636.252,206.005a1.424,1.424,0,0,1-1.335-.928,44.95,44.95,0,0,1-1.385-4.4,1.424,1.424,0,0,1,2.758-.713,42.113,42.113,0,0,0,1.3,4.123,1.425,1.425,0,0,1-1.334,1.921Zm-2.569-11.418a1.424,1.424,0,0,1-1.417-1.3c-.108-1.253-.162-2.524-.162-3.779q0-.42.009-.837a1.424,1.424,0,1,1,2.847.056q-.008.39-.008.782c0,1.174.051,2.363.152,3.535a1.424,1.424,0,0,1-1.3,1.541C633.766,194.586,633.725,194.588,633.684,194.588Zm.609-11.683a1.4,1.4,0,0,1-.27-.026,1.422,1.422,0,0,1-1.13-1.667A44.177,44.177,0,0,1,634,176.729a1.424,1.424,0,0,1,2.726.825,41.383,41.383,0,0,0-1.035,4.2A1.424,1.424,0,0,1,634.293,182.9Zm3.749-11.083a1.425,1.425,0,0,1-1.273-2.06,44.882,44.882,0,0,1,2.273-4.019,1.424,1.424,0,0,1,2.4,1.529,41.908,41.908,0,0,0-2.127,3.762A1.425,1.425,0,0,1,638.042,171.822Zm6.6-9.664a1.424,1.424,0,0,1-1.056-2.378,44.537,44.537,0,0,1,3.268-3.259,1.424,1.424,0,0,1,1.9,2.119,41.519,41.519,0,0,0-3.058,3.048A1.42,1.42,0,0,1,644.638,162.158Zm8.955-7.527a1.424,1.424,0,0,1-.76-2.63,44.4,44.4,0,0,1,4.032-2.251,1.424,1.424,0,0,1,1.255,2.557,41.16,41.16,0,0,0-3.771,2.105A1.416,1.416,0,0,1,653.593,154.631Zm10.658-4.815a1.425,1.425,0,0,1-.4-2.79c.882-.261,1.788-.5,2.691-.706q.9-.207,1.8-.374a1.424,1.424,0,1,1,.524,2.8q-.842.157-1.683.35c-.846.195-1.695.417-2.521.661A1.422,1.422,0,0,1,664.251,149.816Zm16.035-1.614c-.042,0-.085,0-.128-.005a40.58,40.58,0,0,0-4.316-.157,1.424,1.424,0,0,1-.049-2.848,44.6,44.6,0,0,1,4.617.168,1.424,1.424,0,0,1-.125,2.842Z",
    transform: "translate(-632.104 -145.187)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2914",
    "data-name": "Path 2914",
    d: "M730.4,151.193a1.418,1.418,0,0,1-.439-.069c-.7-.225-1.407-.435-2.113-.623a1.424,1.424,0,0,1,.734-2.752c.754.2,1.512.425,2.255.665a1.424,1.424,0,0,1-.437,2.78Z",
    transform: "translate(-672.856 -146.269)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10663",
    "data-name": "Group 10663",
    transform: "translate(27.876 22.518)",
    opacity: 0.64
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2915",
    "data-name": "Path 2915",
    d: "M776.247,189.6a1.424,1.424,0,0,1-1.288-.816c-.312-.659-.646-1.32-.994-1.965a1.424,1.424,0,0,1,2.507-1.353c.371.689.729,1.4,1.062,2.1a1.424,1.424,0,0,1-1.286,2.033Z",
    transform: "translate(-720.964 -184.72)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2916",
    "data-name": "Path 2916",
    d: "M702.9,257.482h-.051a43.864,43.864,0,0,1-4.528-.395,1.424,1.424,0,1,1,.394-2.82,41.189,41.189,0,0,0,4.234.369,1.424,1.424,0,0,1-.05,2.847Zm7.129-.346a1.424,1.424,0,0,1-.186-2.835c1.3-.173,2.6-.408,3.879-.7l.3-.071a1.424,1.424,0,0,1,.663,2.77l-.33.077c-1.361.313-2.754.564-4.138.749A1.529,1.529,0,0,1,710.027,257.136Zm11.112-3.012a1.424,1.424,0,0,1-.554-2.737,41.471,41.471,0,0,0,3.827-1.849,1.424,1.424,0,0,1,1.369,2.5,44.442,44.442,0,0,1-4.09,1.976A1.426,1.426,0,0,1,721.139,254.124Zm9.908-5.857a1.424,1.424,0,0,1-.885-2.541,41.562,41.562,0,0,0,3.193-2.8,1.424,1.424,0,0,1,1.986,2.041,44.592,44.592,0,0,1-3.411,3A1.42,1.42,0,0,1,731.047,248.267Zm7.985-8.286a1.424,1.424,0,0,1-1.147-2.266,41.9,41.9,0,0,0,2.337-3.551,1.424,1.424,0,0,1,2.456,1.443,44.985,44.985,0,0,1-2.5,3.793A1.423,1.423,0,0,1,739.033,239.981Zm5.512-10.105a1.425,1.425,0,0,1-1.33-1.933,41.827,41.827,0,0,0,1.314-4.044,1.424,1.424,0,0,1,2.75.739,44.4,44.4,0,0,1-1.4,4.321A1.425,1.425,0,0,1,744.545,229.876Zm2.633-11.208c-.045,0-.091,0-.137-.007a1.423,1.423,0,0,1-1.282-1.552c.124-1.3.187-2.618.187-3.921l0-.327a1.425,1.425,0,0,1,1.414-1.435h.011a1.424,1.424,0,0,1,1.423,1.414l0,.348c0,1.393-.067,2.8-.2,4.191A1.424,1.424,0,0,1,747.177,218.668Zm-.463-11.5a1.424,1.424,0,0,1-1.4-1.177c-.124-.707-.269-1.421-.43-2.123-.155-.677-.33-1.357-.518-2.023a1.424,1.424,0,1,1,2.741-.774c.2.712.387,1.438.552,2.16.172.75.326,1.513.459,2.267a1.424,1.424,0,0,1-1.4,1.671Z",
    transform: "translate(-687.952 -191.309)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2917",
    "data-name": "Path 2917",
    d: "M684.621,294.736a1.429,1.429,0,0,1-.43-.067c-.74-.234-1.488-.492-2.223-.768a1.424,1.424,0,1,1,1-2.666c.689.257,1.389.5,2.082.718a1.425,1.425,0,0,1-.43,2.782Z",
    transform: "translate(-681.045 -230.525)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2918",
    "data-name": "Path 2918",
    d: "M694.964,227.924q-.22,0-.442,0h0c-.334-.007-.669-.023-1-.047a20.158,20.158,0,0,1-2.766-.394l-.04-.009c-.131-.028-.261-.058-.391-.089a.569.569,0,0,1-.437-.554.55.55,0,0,1,.016-.132.569.569,0,0,1,.686-.422,18.9,18.9,0,0,0,3.961.507A18.751,18.751,0,0,0,713.7,208.439c0-.136,0-.272,0-.407a18.752,18.752,0,0,0-37.5-.4c0,.136,0,.272,0,.408a18.72,18.72,0,0,0,2.453,9.276.569.569,0,0,1-.989.564,19.855,19.855,0,0,1-2.6-9.84c0-.144,0-.289,0-.432a19.916,19.916,0,0,1,19.881-19.461c.145,0,.289,0,.435,0a19.915,19.915,0,0,1,19.461,19.884c0,.144,0,.288,0,.432a19.89,19.89,0,0,1-19.874,19.461Z",
    transform: "translate(-650.593 -163.675)",
    fill: "#fff",
    opacity: 0.56
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10669",
    "data-name": "Group 10669",
    transform: "translate(200.448 284.466)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10666",
    "data-name": "Group 10666",
    transform: "translate(0)",
    opacity: 0.64
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2919",
    "data-name": "Path 2919",
    d: "M286.926,499.514a.569.569,0,0,1-.546-.409c-.136-.461-.262-.927-.379-1.395a.57.57,0,0,1,1.105-.277q.17.68.367,1.351a.57.57,0,0,1-.386.707A.561.561,0,0,1,286.926,499.514Z",
    transform: "translate(-284.935 -453.076)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2920",
    "data-name": "Path 2920",
    d: "M285.174,462.106a.57.57,0,0,1-.562-.478c-.158-.966-.278-1.951-.356-2.928a.569.569,0,1,1,1.135-.091c.076.946.192,1.9.345,2.836a.57.57,0,0,1-.47.654A.583.583,0,0,1,285.174,462.106Zm-.462-5.782h0a.57.57,0,0,1-.568-.571c0-.807.031-1.626.087-2.434.012-.17.025-.341.039-.51a.569.569,0,1,1,1.135.092q-.02.248-.038.5c-.054.783-.083,1.576-.084,2.358A.57.57,0,0,1,284.712,456.324Zm.482-5.779a.526.526,0,0,1-.093-.008.569.569,0,0,1-.469-.654c.16-.967.362-1.938.6-2.887a.57.57,0,0,1,1.1.279c-.231.918-.427,1.859-.582,2.794A.57.57,0,0,1,285.194,450.546Zm1.414-5.623a.561.561,0,0,1-.184-.031.57.57,0,0,1-.355-.723c.317-.927.676-1.851,1.067-2.748a.57.57,0,0,1,1.044.456c-.379.868-.727,1.763-1.033,2.661A.57.57,0,0,1,286.608,444.923Zm2.32-5.314a.565.565,0,0,1-.27-.068.57.57,0,0,1-.231-.772c.466-.864.972-1.717,1.506-2.536a.57.57,0,0,1,.955.622c-.517.793-1.007,1.619-1.458,2.455A.569.569,0,0,1,288.929,439.609Zm3.164-4.863a.57.57,0,0,1-.45-.919c.6-.773,1.238-1.532,1.9-2.256a.57.57,0,0,1,.841.769c-.641.7-1.259,1.435-1.84,2.184A.568.568,0,0,1,292.093,434.746Zm3.915-4.28a.57.57,0,0,1-.387-.987c.718-.666,1.471-1.31,2.241-1.916a.57.57,0,1,1,.7.9c-.746.586-1.476,1.21-2.171,1.855A.565.565,0,0,1,296.008,430.466Zm4.558-3.585a.57.57,0,0,1-.315-1.045c.819-.542,1.667-1.055,2.523-1.525a.569.569,0,0,1,.549,1c-.829.456-1.651.953-2.443,1.478A.57.57,0,0,1,300.566,426.881Zm35.921-1.818a.562.562,0,0,1-.264-.066c-.839-.44-1.707-.852-2.58-1.222a.57.57,0,0,1,.445-1.049c.9.383,1.8.808,2.666,1.264a.57.57,0,0,1-.266,1.074Zm-30.841-.976a.57.57,0,0,1-.233-1.09c.894-.4,1.815-.767,2.737-1.092a.569.569,0,1,1,.378,1.074c-.893.314-1.785.67-2.65,1.058A.579.579,0,0,1,305.646,424.087Zm25.5-1.288a.56.56,0,0,1-.178-.029c-.9-.3-1.824-.559-2.747-.781a.57.57,0,0,1,.266-1.108c.954.229,1.908.5,2.838.808a.569.569,0,0,1-.179,1.11Zm-20.035-.636a.57.57,0,0,1-.144-1.121c.95-.248,1.919-.459,2.881-.627a.57.57,0,0,1,.2,1.123c-.931.162-1.869.366-2.789.607A.6.6,0,0,1,311.113,422.162Zm14.4-.719a.583.583,0,0,1-.088-.007c-.932-.145-1.888-.254-2.838-.322a.569.569,0,1,1,.083-1.136c.981.071,1.967.183,2.931.333a.57.57,0,0,1-.087,1.132Zm-8.685-.278a.57.57,0,0,1-.051-1.137c.976-.089,1.967-.138,2.945-.145h0a.57.57,0,0,1,0,1.139c-.947.007-1.906.055-2.851.141Z",
    transform: "translate(-284.142 -419.883)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2921",
    "data-name": "Path 2921",
    d: "M381.262,431.495a.563.563,0,0,1-.325-.1q-.574-.4-1.166-.776a.57.57,0,1,1,.613-.96q.61.39,1.2.8a.57.57,0,0,1-.326,1.037Z",
    transform: "translate(-325.188 -424.051)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10667",
    "data-name": "Group 10667",
    transform: "translate(13.867 28.293)",
    opacity: 0.64
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2922",
    "data-name": "Path 2922",
    d: "M407.845,472.1a.57.57,0,0,1-.562-.479c-.075-.463-.158-.922-.251-1.378a.57.57,0,1,1,1.116-.226q.144.708.259,1.423a.571.571,0,0,1-.472.653A.559.559,0,0,1,407.845,472.1Z",
    transform: "translate(-350.896 -469.555)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2923",
    "data-name": "Path 2923",
    d: "M333.274,516.295c-.563,0-1.134-.013-1.693-.039a.571.571,0,0,1-.543-.6.577.577,0,0,1,.6-.542c.933.044,1.881.05,2.81.019a.554.554,0,0,1,.589.55.569.569,0,0,1-.55.588Q333.88,516.3,333.274,516.295Zm4.035-.231a.569.569,0,0,1-.064-1.135c.924-.106,1.858-.252,2.775-.433a.569.569,0,1,1,.222,1.117c-.948.188-1.912.339-2.867.447A.508.508,0,0,1,337.309,516.064Zm-8.547-.055a.629.629,0,0,1-.073,0c-.959-.122-1.922-.283-2.862-.48a.569.569,0,0,1,.234-1.115c.91.191,1.843.347,2.772.465a.57.57,0,0,1-.071,1.135Zm14.144-1.053a.57.57,0,0,1-.156-1.118c.9-.256,1.8-.551,2.667-.877a.57.57,0,1,1,.4,1.067c-.9.337-1.827.642-2.755.906A.569.569,0,0,1,342.906,514.956Zm-19.731-.118a.552.552,0,0,1-.162-.023c-.926-.275-1.851-.59-2.747-.936a.569.569,0,1,1,.411-1.062c.868.336,1.763.641,2.66.907a.569.569,0,0,1-.161,1.115Zm25.072-1.884A.57.57,0,0,1,348,511.87c.842-.4,1.68-.831,2.492-1.3a.57.57,0,0,1,.566.989c-.839.48-1.7.93-2.573,1.339A.564.564,0,0,1,348.247,512.955Zm-30.4-.176a.576.576,0,0,1-.248-.056c-.863-.418-1.724-.878-2.559-1.369a.569.569,0,0,1,.577-.982c.808.475,1.642.921,2.478,1.325a.57.57,0,0,1-.248,1.082ZM353.2,510.12a.57.57,0,0,1-.323-1.04c.77-.527,1.527-1.092,2.252-1.68a.57.57,0,0,1,.717.886c-.748.606-1.53,1.189-2.325,1.734A.569.569,0,0,1,353.2,510.12Zm4.433-3.593a.57.57,0,0,1-.393-.982c.674-.641,1.331-1.32,1.954-2.018a.57.57,0,0,1,.85.759c-.644.721-1.323,1.422-2.019,2.085A.568.568,0,0,1,357.631,506.527Zm3.8-4.257a.57.57,0,0,1-.453-.914c.564-.743,1.1-1.519,1.605-2.306a.57.57,0,0,1,.961.612c-.518.813-1.076,1.614-1.658,2.383A.57.57,0,0,1,361.432,502.271Zm3.068-4.813a.57.57,0,0,1-.5-.836c.435-.823.843-1.676,1.211-2.536a.57.57,0,0,1,1.047.449c-.38.888-.8,1.769-1.252,2.62A.569.569,0,0,1,364.5,497.457Zm2.25-5.246a.577.577,0,0,1-.182-.03.57.57,0,0,1-.359-.721c.3-.882.56-1.789.784-2.7a.57.57,0,0,1,1.106.274c-.232.937-.5,1.874-.81,2.785A.57.57,0,0,1,366.75,492.211Zm1.37-5.538a.648.648,0,0,1-.092-.007.57.57,0,0,1-.47-.654c.15-.921.264-1.859.341-2.789a.569.569,0,1,1,1.135.093c-.079.959-.2,1.928-.351,2.878A.569.569,0,0,1,368.12,486.673Zm.465-5.687a.57.57,0,0,1-.57-.57v-.074c0-.911-.036-1.832-.108-2.736a.57.57,0,0,1,1.136-.089c.073.934.111,1.884.111,2.825v.074A.569.569,0,0,1,368.585,480.986Z",
    transform: "translate(-311.188 -472.756)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2924",
    "data-name": "Path 2924",
    d: "M310.2,533.207a.568.568,0,0,1-.328-.1q-.592-.417-1.165-.857a.57.57,0,1,1,.694-.9q.555.426,1.128.829a.57.57,0,0,1-.329,1.035Z",
    transform: "translate(-308.487 -496.098)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10668",
    "data-name": "Group 10668",
    transform: "translate(8.572 8.268)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2925",
    "data-name": "Path 2925",
    d: "M307.449,481.358a.426.426,0,0,0,.476.13l4.846-1.782a22.5,22.5,0,0,0,6.416,3.455l1.182,5.023a.424.424,0,0,0,.37.325l6.162.624a.425.425,0,0,0,.428-.244l2.165-4.684a22.486,22.486,0,0,0,6.978-2.1l4.39,2.718a.424.424,0,0,0,.492-.032l4.8-3.916a.424.424,0,0,0,.13-.475l-1.782-4.846a22.477,22.477,0,0,0,3.455-6.416l5.023-1.182a.424.424,0,0,0,.325-.37l.624-6.162a.424.424,0,0,0-.244-.428L349,458.834a22.478,22.478,0,0,0-2.1-6.979l2.718-4.39a.425.425,0,0,0-.032-.492l-3.915-4.8a.423.423,0,0,0-.475-.13l-4.846,1.782a22.494,22.494,0,0,0-6.416-3.455l-1.182-5.023a.423.423,0,0,0-.37-.325l-6.162-.624a.424.424,0,0,0-.428.244l-2.166,4.683a22.493,22.493,0,0,0-6.978,2.1l-4.39-2.718a.424.424,0,0,0-.492.032l-4.8,3.916a.425.425,0,0,0-.13.475l1.782,4.846a22.494,22.494,0,0,0-3.455,6.416l-5.023,1.182a.425.425,0,0,0-.325.37l-.624,6.162a.424.424,0,0,0,.244.428l4.684,2.165a22.494,22.494,0,0,0,2.1,6.979l-2.718,4.39a.424.424,0,0,0,.032.492Z",
    transform: "translate(-299.191 -434.398)",
    fill: "url(#linear-gradient-16)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2926",
    "data-name": "Path 2926",
    d: "M342.65,483.932a6.076,6.076,0,1,1,.889-.066h0A6.123,6.123,0,0,1,342.65,483.932Zm.805-.629h0Zm-.8-10.371a4.93,4.93,0,1,0,.715,9.807h0a4.93,4.93,0,0,0-.715-9.807Z",
    transform: "translate(-315.285 -450.493)",
    fill: "#fff",
    opacity: 0.56
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2927",
    "data-name": "Path 2927",
    d: "M335.713,486.079a15.771,15.771,0,0,1-1.593-.08,15.6,15.6,0,0,1-3.073-.627l-.159-.051a.568.568,0,0,1-.394-.541.579.579,0,0,1,.028-.177.57.57,0,0,1,.717-.366,14.469,14.469,0,0,0,3,.628h0l.053.005a14.374,14.374,0,0,0,15.7-12.857q.074-.742.075-1.477a14.376,14.376,0,1,0-27.395,6.128.564.564,0,0,1,.054.242.569.569,0,0,1-1.085.242,15.515,15.515,0,1,1,29.565-6.615,15.805,15.805,0,0,1-.08,1.595,15.516,15.516,0,0,1-15.406,13.952Z",
    transform: "translate(-308.22 -443.286)",
    fill: "#fff",
    opacity: 0.56
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10673",
    "data-name": "Group 10673",
    transform: "translate(494.527 135.177)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10670",
    "data-name": "Group 10670",
    transform: "translate(0 0)",
    opacity: 0.64
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2928",
    "data-name": "Path 2928",
    d: "M805.25,281.8a1.425,1.425,0,0,1-1.366-1.023c-.219-.747-.424-1.506-.611-2.256a1.424,1.424,0,1,1,2.764-.686c.177.711.371,1.431.579,2.139a1.425,1.425,0,0,1-1.367,1.826Z",
    transform: "translate(-801.639 -208.988)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2929",
    "data-name": "Path 2929",
    d: "M802.144,220.941a1.424,1.424,0,0,1-1.415-1.276c-.165-1.58-.263-3.186-.292-4.772a1.425,1.425,0,0,1,1.4-1.45,1.41,1.41,0,0,1,1.45,1.4c.028,1.506.121,3.03.277,4.529a1.424,1.424,0,0,1-1.269,1.564A1.3,1.3,0,0,1,802.144,220.941Zm.1-12.208a1.421,1.421,0,0,1-1.415-1.591c.187-1.581.444-3.168.764-4.717a1.424,1.424,0,0,1,2.789.575c-.3,1.47-.547,2.977-.726,4.477A1.424,1.424,0,0,1,802.24,208.733Zm2.78-11.882a1.425,1.425,0,0,1-1.341-1.9c.533-1.493,1.137-2.984,1.8-4.429a1.424,1.424,0,0,1,2.59,1.182c-.626,1.372-1.2,2.786-1.705,4.2A1.425,1.425,0,0,1,805.02,196.851Zm5.368-10.965a1.425,1.425,0,0,1-1.2-2.19c.853-1.336,1.775-2.654,2.741-3.917a1.424,1.424,0,0,1,2.262,1.732c-.918,1.2-1.793,2.449-2.6,3.718A1.424,1.424,0,0,1,810.388,185.886Zm7.677-9.494a1.424,1.424,0,0,1-1-2.437c1.129-1.116,2.321-2.2,3.539-3.212a1.424,1.424,0,1,1,1.822,2.188c-1.157.964-2.287,1.99-3.36,3.049A1.419,1.419,0,0,1,818.065,176.392Zm9.583-7.559a1.424,1.424,0,0,1-.753-2.633c1.348-.84,2.748-1.63,4.162-2.35a1.424,1.424,0,1,1,1.292,2.538c-1.341.684-2.67,1.434-3.95,2.231A1.42,1.42,0,0,1,827.649,168.833ZM879,165.48a1.418,1.418,0,0,1-.587-.128c-1.375-.623-2.79-1.193-4.209-1.694a1.424,1.424,0,0,1,.949-2.686c1.5.529,2.988,1.129,4.436,1.786A1.424,1.424,0,0,1,879,165.48Zm-40.335-1.893a1.425,1.425,0,0,1-.464-2.771c1.5-.518,3.043-.977,4.579-1.363a1.424,1.424,0,1,1,.694,2.762c-1.458.366-2.919.8-4.345,1.294A1.426,1.426,0,0,1,838.662,163.586Zm28.722-1.865a1.436,1.436,0,0,1-.285-.028c-1.478-.3-2.986-.541-4.482-.713a1.424,1.424,0,1,1,.328-2.829c1.576.182,3.164.435,4.721.751a1.424,1.424,0,0,1-.281,2.82Zm-16.813-.791a1.424,1.424,0,0,1-.15-2.84c1.579-.169,3.183-.272,4.77-.3h.031a1.424,1.424,0,0,1,.029,2.847c-1.505.032-3.028.129-4.526.289A1.41,1.41,0,0,1,850.571,160.93Z",
    transform: "translate(-800.437 -157.785)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2930",
    "data-name": "Path 2930",
    d: "M950.926,176.758a1.417,1.417,0,0,1-.813-.255c-.6-.414-1.216-.828-1.846-1.228a1.424,1.424,0,1,1,1.528-2.4c.664.422,1.318.857,1.946,1.294a1.424,1.424,0,0,1-.814,2.593Z",
    transform: "translate(-863.779 -164.183)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10671",
    "data-name": "Group 10671",
    transform: "translate(21.409 43.691)",
    opacity: 0.64
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2931",
    "data-name": "Path 2931",
    d: "M992.048,239.58a1.425,1.425,0,0,1-1.4-1.2c-.116-.729-.25-1.463-.4-2.183a1.424,1.424,0,0,1,2.792-.566c.154.759.294,1.533.416,2.3a1.424,1.424,0,0,1-1.181,1.631A1.464,1.464,0,0,1,992.048,239.58Z",
    transform: "translate(-903.529 -234.49)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2932",
    "data-name": "Path 2932",
    d: "M878.94,310.125c-.669.009-1.3-.011-1.959-.034a1.424,1.424,0,1,1,.1-2.846c.621.022,1.243.039,1.86.031.866,0,1.741-.022,2.6-.064a1.424,1.424,0,1,1,.142,2.845C880.774,310.1,879.851,310.125,878.94,310.125Zm-9.317-.784a1.511,1.511,0,0,1-.241-.02c-1.542-.263-3.09-.594-4.6-.984a1.424,1.424,0,1,1,.711-2.758c1.434.37,2.9.685,4.366.934a1.424,1.424,0,0,1-.237,2.828ZM889,309.184a1.424,1.424,0,0,1-.263-2.824c1.458-.275,2.92-.615,4.347-1.012a1.424,1.424,0,0,1,.762,2.744c-1.5.418-3.044.777-4.581,1.066A1.411,1.411,0,0,1,889,309.184Zm-30.931-3.153a1.408,1.408,0,0,1-.541-.108c-1.446-.595-2.883-1.258-4.271-1.971a1.424,1.424,0,0,1,1.3-2.533c1.318.677,2.681,1.307,4.053,1.871a1.424,1.424,0,0,1-.542,2.741Zm42.41-.362a1.424,1.424,0,0,1-.566-2.731c1.364-.591,2.715-1.244,4.018-1.942a1.424,1.424,0,1,1,1.346,2.51c-1.372.736-2.8,1.424-4.233,2.045A1.412,1.412,0,0,1,900.482,305.669Zm10.43-5.949a1.424,1.424,0,0,1-.838-2.576c1.2-.873,2.379-1.806,3.5-2.773a1.424,1.424,0,0,1,1.86,2.157c-1.181,1.018-2.421,2-3.686,2.92A1.42,1.42,0,0,1,910.913,299.719Zm8.887-8.078a1.424,1.424,0,0,1-1.067-2.367c.982-1.111,1.928-2.278,2.813-3.467a1.424,1.424,0,0,1,2.285,1.7c-.932,1.253-1.929,2.482-2.963,3.653A1.421,1.421,0,0,1,919.8,291.641Zm6.914-9.825a1.424,1.424,0,0,1-1.246-2.111c.714-1.3,1.381-2.642,1.985-4a1.424,1.424,0,1,1,2.6,1.157c-.635,1.43-1.339,2.847-2.091,4.215A1.425,1.425,0,0,1,926.714,281.816Zm4.591-11.1a1.44,1.44,0,0,1-.4-.056,1.424,1.424,0,0,1-.974-1.763c.41-1.42.764-2.879,1.054-4.336a1.424,1.424,0,1,1,2.793.556c-.305,1.535-.679,3.072-1.111,4.57A1.425,1.425,0,0,1,931.3,270.711Zm2.04-11.836-.089,0a1.424,1.424,0,0,1-1.334-1.509c.068-1.1.1-2.216.1-3.313q0-.577-.013-1.152a1.424,1.424,0,0,1,2.847-.06q.013.6.013,1.212c0,1.156-.036,2.33-.108,3.489A1.423,1.423,0,0,1,933.344,258.876Z",
    transform: "translate(-844.248 -241.787)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2933",
    "data-name": "Path 2933",
    d: "M841.282,333.941a1.417,1.417,0,0,1-.817-.259c-.641-.451-1.275-.915-1.884-1.382a1.424,1.424,0,0,1,1.733-2.26c.578.443,1.179.884,1.788,1.311a1.424,1.424,0,0,1-.819,2.589Z",
    transform: "translate(-838.023 -275.489)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10672",
    "data-name": "Group 10672",
    transform: "translate(13.775 13.304)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2934",
    "data-name": "Path 2934",
    d: "M837.375,253.677a.657.657,0,0,0,.734.2l7.485-2.753a34.727,34.727,0,0,0,9.91,5.337l1.826,7.758a.656.656,0,0,0,.572.5l9.517.964a.656.656,0,0,0,.661-.377l3.345-7.234a34.742,34.742,0,0,0,10.778-3.242l6.781,4.2a.655.655,0,0,0,.759-.05l7.412-6.048a.655.655,0,0,0,.2-.734l-2.753-7.485a34.759,34.759,0,0,0,5.337-9.91l7.758-1.826a.654.654,0,0,0,.5-.572l.964-9.517a.655.655,0,0,0-.377-.661l-7.234-3.345a34.742,34.742,0,0,0-3.241-10.778l4.2-6.781a.656.656,0,0,0-.049-.759l-6.049-7.412a.655.655,0,0,0-.734-.2l-7.485,2.753a34.743,34.743,0,0,0-9.91-5.337l-1.826-7.758a.654.654,0,0,0-.571-.5l-9.518-.964a.656.656,0,0,0-.661.377l-3.344,7.234A34.746,34.746,0,0,0,851.584,192l-6.781-4.2a.654.654,0,0,0-.759.05l-7.412,6.048a.655.655,0,0,0-.2.734l2.752,7.486a34.729,34.729,0,0,0-5.337,9.91l-7.758,1.826a.656.656,0,0,0-.5.572l-.964,9.517a.655.655,0,0,0,.376.661l7.235,3.344a34.726,34.726,0,0,0,3.241,10.779l-4.2,6.781a.656.656,0,0,0,.049.759Z",
    transform: "translate(-824.62 -181.141)",
    fill: "url(#linear-gradient-17)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2935",
    "data-name": "Path 2935",
    d: "M891.1,257.852a10.216,10.216,0,1,1,1.51-.111h0A10.313,10.313,0,0,1,891.1,257.852Zm1.261-1.8h0Zm-1.224-15.191a6.858,6.858,0,0,0-1,.074,6.754,6.754,0,1,0,1-.074Z",
    transform: "translate(-848.852 -205.374)",
    fill: "#fff",
    opacity: 0.56
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2936",
    "data-name": "Path 2936",
    d: "M881.266,260.893a24.15,24.15,0,0,1-2.428-.123h0a23.84,23.84,0,0,1-4.928-1.033.569.569,0,0,1-.394-.541.576.576,0,0,1,.028-.176.569.569,0,0,1,.717-.366,22.751,22.751,0,0,0,4.692.983,22.513,22.513,0,0,0,24.667-20.129,22.876,22.876,0,0,0,.117-2.314,22.515,22.515,0,0,0-44.915-2.224,22.741,22.741,0,0,0-.115,2.285,22.439,22.439,0,0,0,2.125,9.538.57.57,0,1,1-1.032.484,23.652,23.652,0,1,1,21.465,13.618Z",
    transform: "translate(-838.801 -195.105)",
    fill: "#fff",
    opacity: 0.56
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10677",
    "data-name": "Group 10677",
    transform: "translate(575.186 105.257)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10674",
    "data-name": "Group 10674",
    opacity: 0.64
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2937",
    "data-name": "Path 2937",
    d: "M945.06,172a1.425,1.425,0,0,1-1.366-1.024c-.223-.76-.42-1.54-.583-2.317a1.424,1.424,0,1,1,2.787-.585c.148.7.326,1.409.528,2.1A1.425,1.425,0,0,1,945.06,172Z",
    transform: "translate(-942.491 -131.806)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2938",
    "data-name": "Path 2938",
    d: "M943.469,135.837l-.068,0a1.423,1.423,0,0,1-1.356-1.489c.011-.23.025-.46.041-.691a31.054,31.054,0,0,1,.553-4.068,1.424,1.424,0,1,1,2.79.571,28.261,28.261,0,0,0-.5,3.694c-.015.21-.027.419-.037.628A1.424,1.424,0,0,1,943.469,135.837Zm2.965-11.567a1.425,1.425,0,0,1-1.276-2.053,30.855,30.855,0,0,1,2.451-4.128,1.424,1.424,0,0,1,2.328,1.641,28,28,0,0,0-2.223,3.745A1.426,1.426,0,0,1,946.435,124.271Zm7.351-9.415a1.424,1.424,0,0,1-.922-2.51,30.931,30.931,0,0,1,3.888-2.809,1.424,1.424,0,1,1,1.483,2.43,28.071,28.071,0,0,0-3.529,2.551A1.421,1.421,0,0,1,953.786,114.855Zm10.483-5.711a1.424,1.424,0,0,1-.411-2.788,30.484,30.484,0,0,1,4.689-1.021,1.424,1.424,0,1,1,.385,2.821,27.764,27.764,0,0,0-4.252.926A1.438,1.438,0,0,1,964.269,109.145Zm16.389-.154a1.426,1.426,0,0,1-.385-.053A27.943,27.943,0,0,0,976,108.1a1.424,1.424,0,0,1,.331-2.829,30.847,30.847,0,0,1,4.71.928,1.424,1.424,0,0,1-.383,2.8Z",
    transform: "translate(-942.044 -105.257)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2939",
    "data-name": "Path 2939",
    d: "M1022.727,116a1.417,1.417,0,0,1-.812-.255c-.587-.408-1.2-.8-1.825-1.167a1.424,1.424,0,1,1,1.44-2.457c.688.4,1.365.836,2.012,1.286a1.424,1.424,0,0,1-.815,2.593Z",
    transform: "translate(-975.333 -108.126)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10675",
    "data-name": "Group 10675",
    transform: "translate(11.461 23.248)",
    opacity: 0.64
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2940",
    "data-name": "Path 2940",
    d: "M1045.623,151.17a1.424,1.424,0,0,1-1.412-1.251c-.088-.716-.2-1.435-.348-2.138a1.424,1.424,0,1,1,2.791-.566c.157.775.286,1.568.383,2.358a1.424,1.424,0,0,1-1.24,1.587A1.4,1.4,0,0,1,1045.623,151.17Z",
    transform: "translate(-997.316 -146.073)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2941",
    "data-name": "Path 2941",
    d: "M990.106,191.195a1.424,1.424,0,0,1-.11-2.843,27.887,27.887,0,0,0,4.229-.662,1.424,1.424,0,1,1,.656,2.771,30.642,30.642,0,0,1-4.663.73C990.181,191.193,990.143,191.195,990.106,191.195Zm-7.293-.335a1.391,1.391,0,0,1-.242-.021,30.577,30.577,0,0,1-4.579-1.152,1.424,1.424,0,0,1,.906-2.7,27.775,27.775,0,0,0,4.152,1.046,1.424,1.424,0,0,1-.238,2.827Zm18.577-2.921a1.424,1.424,0,0,1-.664-2.684,28.071,28.071,0,0,0,3.627-2.276,1.424,1.424,0,1,1,1.694,2.289,30.885,30.885,0,0,1-4,2.507A1.409,1.409,0,0,1,1001.391,187.939Zm9.1-7.43a1.425,1.425,0,0,1-1.1-2.326,27.864,27.864,0,0,0,2.448-3.514,1.424,1.424,0,1,1,2.455,1.443,30.745,30.745,0,0,1-2.7,3.873A1.421,1.421,0,0,1,1010.487,180.509Zm5.456-10.4a1.427,1.427,0,0,1-1.369-1.818,28.04,28.04,0,0,0,.862-4.193,1.424,1.424,0,1,1,2.825.358,30.724,30.724,0,0,1-.95,4.622A1.425,1.425,0,0,1,1015.943,170.1Z",
    transform: "translate(-968.559 -153.293)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2942",
    "data-name": "Path 2942",
    d: "M965.447,201.351a1.421,1.421,0,0,1-.775-.23c-.667-.434-1.322-.9-1.949-1.378a1.424,1.424,0,0,1,1.733-2.261c.569.437,1.165.857,1.77,1.251a1.424,1.424,0,0,1-.778,2.618Z",
    transform: "translate(-962.165 -168.073)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10676",
    "data-name": "Group 10676",
    transform: "translate(8.024 7.603)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2943",
    "data-name": "Path 2943",
    d: "M962.976,157.528a.352.352,0,0,0,.394.108l4.016-1.477a18.648,18.648,0,0,0,5.318,2.864l.98,4.163a.353.353,0,0,0,.307.269l5.107.517a.353.353,0,0,0,.355-.2l1.794-3.882a18.644,18.644,0,0,0,5.784-1.739l3.638,2.252a.352.352,0,0,0,.407-.026l3.978-3.246a.351.351,0,0,0,.108-.394l-1.477-4.017a18.633,18.633,0,0,0,2.863-5.318l4.163-.98a.35.35,0,0,0,.269-.307l.517-5.107a.351.351,0,0,0-.2-.354l-3.882-1.795a18.647,18.647,0,0,0-1.739-5.784l2.253-3.639a.351.351,0,0,0-.027-.407l-3.246-3.977a.351.351,0,0,0-.394-.108l-4.017,1.477a18.629,18.629,0,0,0-5.317-2.863l-.98-4.163a.353.353,0,0,0-.307-.269l-5.107-.517a.352.352,0,0,0-.355.2l-1.795,3.882a18.627,18.627,0,0,0-5.784,1.739l-3.639-2.253a.351.351,0,0,0-.408.027l-3.977,3.246a.351.351,0,0,0-.108.394l1.477,4.017a18.655,18.655,0,0,0-2.864,5.318l-4.163.98a.35.35,0,0,0-.269.306l-.518,5.107a.352.352,0,0,0,.2.355l3.882,1.795a18.645,18.645,0,0,0,1.739,5.784l-2.252,3.639a.352.352,0,0,0,.026.407Z",
    transform: "translate(-956.131 -118.605)",
    fill: "url(#linear-gradient-18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2944",
    "data-name": "Path 2944",
    d: "M991.207,159.962a6.287,6.287,0,1,1,.927-.068h0A6.37,6.37,0,0,1,991.207,159.962Zm.019-9.118a2.933,2.933,0,0,0-.422.031,2.849,2.849,0,0,0,.831,5.638h0a2.85,2.85,0,0,0-.41-5.669Z",
    transform: "translate(-968.536 -131.009)",
    fill: "#fff",
    opacity: 0.56
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2945",
    "data-name": "Path 2945",
    d: "M986.329,161.464a13.117,13.117,0,0,1-3.886-.588l-.144-.046a.571.571,0,0,1-.394-.542.578.578,0,0,1,.028-.176.57.57,0,0,1,.718-.366,11.914,11.914,0,0,0,2.463.517,11.734,11.734,0,0,0,8.51-2.479l.054-.042.1-.08a11.738,11.738,0,0,0,4.286-7.964,12.12,12.12,0,0,0,.062-1.215,11.818,11.818,0,1,0-22.52,5.038.563.563,0,0,1,.054.242.569.569,0,0,1-1.085.242,12.915,12.915,0,0,1-1.223-5.489c0-.438.022-.877.066-1.315a12.957,12.957,0,0,1,25.848,1.28,13.224,13.224,0,0,1-.067,1.332,12.959,12.959,0,0,1-12.865,11.652Z",
    transform: "translate(-963.541 -125.898)",
    fill: "#fff",
    opacity: 0.56
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10681",
    "data-name": "Group 10681",
    transform: "translate(348.755 166.69)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10678",
    "data-name": "Group 10678",
    transform: "translate(0)",
    opacity: 0.64
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2946",
    "data-name": "Path 2946",
    d: "M546.629,271.142a.569.569,0,0,1-.546-.41c-.135-.46-.26-.934-.37-1.406a.57.57,0,1,1,1.109-.26c.106.453.225.906.354,1.346a.57.57,0,0,1-.386.707A.585.585,0,0,1,546.629,271.142Z",
    transform: "translate(-545.024 -237.005)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2947",
    "data-name": "Path 2947",
    d: "M545.26,243.033a.57.57,0,0,1-.565-.5,26.425,26.425,0,0,1-.18-2.941.569.569,0,0,1,.567-.572h0a.57.57,0,0,1,.57.567,25.185,25.185,0,0,0,.172,2.813.57.57,0,0,1-.5.633A.539.539,0,0,1,545.26,243.033Zm-.03-5.755a.535.535,0,0,1-.06,0,.569.569,0,0,1-.507-.626,26.544,26.544,0,0,1,.471-2.906.57.57,0,1,1,1.112.245,25.489,25.489,0,0,0-.451,2.781A.57.57,0,0,1,545.23,237.278Zm1.237-5.618a.56.56,0,0,1-.184-.031.569.569,0,0,1-.355-.723,26.265,26.265,0,0,1,1.108-2.73.57.57,0,1,1,1.03.487,24.961,24.961,0,0,0-1.06,2.612A.569.569,0,0,1,546.466,231.66Zm2.461-5.2a.569.569,0,0,1-.484-.869,26.4,26.4,0,0,1,1.689-2.413.57.57,0,1,1,.9.7,25.4,25.4,0,0,0-1.616,2.308A.569.569,0,0,1,548.927,226.456Zm3.558-4.523a.57.57,0,0,1-.406-.969,26.488,26.488,0,0,1,2.181-1.979.57.57,0,1,1,.717.885,25.3,25.3,0,0,0-2.086,1.894A.569.569,0,0,1,552.485,221.933Zm4.469-3.624a.57.57,0,0,1-.308-1.049,26.475,26.475,0,0,1,2.563-1.447.569.569,0,1,1,.5,1.021,25.39,25.39,0,0,0-2.453,1.386A.567.567,0,0,1,556.954,218.309Zm24.808-1.631a.562.562,0,0,1-.242-.054,24.931,24.931,0,0,0-2.614-1.05.57.57,0,1,1,.365-1.079,26.014,26.014,0,0,1,2.733,1.1.569.569,0,0,1-.242,1.085Zm-19.65-.913a.569.569,0,0,1-.194-1.1,26.126,26.126,0,0,1,2.823-.841.569.569,0,0,1,.264,1.108,25.207,25.207,0,0,0-2.7.8A.561.561,0,0,1,562.112,215.765Zm14.2-.928a.557.557,0,0,1-.121-.013,25.222,25.222,0,0,0-2.784-.441.57.57,0,0,1,.116-1.134,26.817,26.817,0,0,1,2.909.462.57.57,0,0,1-.12,1.127Zm-8.6-.4a.57.57,0,0,1-.068-1.135,26.414,26.414,0,0,1,2.939-.189h0a.57.57,0,0,1,0,1.139,24.924,24.924,0,0,0-2.811.182A.571.571,0,0,1,567.708,214.435Z",
    transform: "translate(-544.515 -213.111)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2948",
    "data-name": "Path 2948",
    d: "M615.166,221.724a.567.567,0,0,1-.325-.1c-.383-.266-.774-.522-1.164-.763a.57.57,0,1,1,.6-.97c.408.252.817.519,1.217.8a.57.57,0,0,1-.325,1.038Z",
    transform: "translate(-574.167 -215.992)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10679",
    "data-name": "Group 10679",
    transform: "translate(10.101 20.611)",
    opacity: 0.64
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2949",
    "data-name": "Path 2949",
    d: "M634.835,251.836a.57.57,0,0,1-.563-.488c-.065-.452-.145-.913-.239-1.37a.57.57,0,0,1,1.116-.227c.1.478.181.961.25,1.434a.569.569,0,0,1-.482.645A.509.509,0,0,1,634.835,251.836Z",
    transform: "translate(-593.14 -249.296)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2950",
    "data-name": "Path 2950",
    d: "M581.213,284.512q-.615,0-1.235-.029a.57.57,0,1,1,.051-1.138,25.587,25.587,0,0,0,2.773-.023.57.57,0,1,1,.072,1.137C582.324,284.494,581.765,284.512,581.213,284.512Zm-4.03-.313a.581.581,0,0,1-.089-.007,26.439,26.439,0,0,1-2.834-.6.57.57,0,1,1,.3-1.1,25.187,25.187,0,0,0,2.712.578.57.57,0,0,1-.087,1.132Zm8.469-.073a.57.57,0,0,1-.1-1.131,24.9,24.9,0,0,0,2.7-.628.57.57,0,1,1,.32,1.094,26.18,26.18,0,0,1-2.822.657A.576.576,0,0,1,585.653,284.126Zm-13.934-1.412a.565.565,0,0,1-.209-.04,26.183,26.183,0,0,1-2.633-1.213.569.569,0,1,1,.533-1.006,25.337,25.337,0,0,0,2.518,1.16.569.569,0,0,1-.209,1.1Zm19.367-.176a.57.57,0,0,1-.22-1.1,25.4,25.4,0,0,0,2.494-1.206.57.57,0,1,1,.552,1,26.667,26.667,0,0,1-2.607,1.261A.572.572,0,0,1,591.086,282.538Zm4.951-2.74a.57.57,0,0,1-.33-1.034,25.493,25.493,0,0,0,2.173-1.722.57.57,0,0,1,.755.854,26.811,26.811,0,0,1-2.27,1.8A.568.568,0,0,1,596.037,279.8Zm4.237-3.754a.569.569,0,0,1-.422-.952,25.277,25.277,0,0,0,1.746-2.152.569.569,0,1,1,.923.668,26.308,26.308,0,0,1-1.826,2.25A.567.567,0,0,1,600.274,276.044Zm3.319-4.585a.569.569,0,0,1-.495-.851,25.132,25.132,0,0,0,1.233-2.483.569.569,0,1,1,1.046.449,26.162,26.162,0,0,1-1.288,2.6A.57.57,0,0,1,603.593,271.458Zm2.233-5.2a.58.58,0,0,1-.166-.024.569.569,0,0,1-.379-.71,25.446,25.446,0,0,0,.656-2.693.57.57,0,0,1,1.12.208,26.558,26.558,0,0,1-.685,2.815A.57.57,0,0,1,605.826,266.254Zm1.036-5.565h-.042a.57.57,0,0,1-.527-.61l.01-.145c.041-.586.061-1.179.061-1.762q0-.435-.015-.866a.57.57,0,0,1,.55-.588.554.554,0,0,1,.588.55c.011.3.015.6.015.9,0,.609-.021,1.229-.063,1.84l-.011.151A.57.57,0,0,1,606.862,260.689Z",
    transform: "translate(-564.971 -252.489)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2951",
    "data-name": "Path 2951",
    d: "M563.97,296.189a.57.57,0,0,1-.32-.1c-.394-.268-.79-.555-1.178-.853a.57.57,0,0,1,.693-.9c.371.285.751.559,1.127.816a.57.57,0,0,1-.322,1.04Z",
    transform: "translate(-562.249 -268.629)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10680",
    "data-name": "Group 10680",
    transform: "translate(6.398 6.177)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2952",
    "data-name": "Path 2952",
    d: "M561.764,258.163a.309.309,0,0,0,.346.095l3.53-1.3a16.384,16.384,0,0,0,4.673,2.517l.861,3.659a.309.309,0,0,0,.269.236l4.488.455a.31.31,0,0,0,.312-.178l1.577-3.411a16.38,16.38,0,0,0,5.083-1.529l3.2,1.98a.31.31,0,0,0,.358-.023l3.495-2.853a.308.308,0,0,0,.095-.346l-1.3-3.53a16.368,16.368,0,0,0,2.517-4.674l3.659-.861a.309.309,0,0,0,.237-.269l.454-4.488a.309.309,0,0,0-.178-.312l-3.412-1.577a16.391,16.391,0,0,0-1.528-5.083l1.979-3.2a.308.308,0,0,0-.023-.358l-2.852-3.5a.31.31,0,0,0-.346-.1l-3.53,1.3a16.387,16.387,0,0,0-4.674-2.516l-.861-3.659a.308.308,0,0,0-.27-.236l-4.488-.455a.308.308,0,0,0-.312.178l-1.577,3.412a16.378,16.378,0,0,0-5.083,1.528l-3.2-1.979a.309.309,0,0,0-.358.023l-3.5,2.852a.309.309,0,0,0-.094.346l1.3,3.53a16.387,16.387,0,0,0-2.517,4.674l-3.659.861a.309.309,0,0,0-.236.27l-.455,4.488a.31.31,0,0,0,.178.312l3.412,1.577a16.4,16.4,0,0,0,1.528,5.083l-1.979,3.2a.309.309,0,0,0,.023.358Z",
    transform: "translate(-555.748 -223.956)",
    fill: "url(#linear-gradient-19)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2953",
    "data-name": "Path 2953",
    d: "M587.281,260.075a4.592,4.592,0,1,1,.677-.05h0A4.607,4.607,0,0,1,587.281,260.075Zm.018-8.013a3.481,3.481,0,0,0-.509.037,3.436,3.436,0,1,0,1,6.8h0a3.437,3.437,0,0,0-.493-6.836Z",
    transform: "translate(-567.355 -235.563)",
    fill: "#fff",
    opacity: 0.56
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2954",
    "data-name": "Path 2954",
    d: "M582.222,261.639a11.622,11.622,0,0,1-1.163-.059h0a11.585,11.585,0,0,1-2.232-.452l-.019-.006-.136-.043a.57.57,0,0,1,.351-1.084,10.408,10.408,0,0,0,2.151.451l.07.007a10.347,10.347,0,0,0,9.733-4.829,10.239,10.239,0,0,0,1.479-4.215c.008-.062.015-.125.021-.187a10.316,10.316,0,1,0-19.607,3.337.57.57,0,1,1-1.031.485,11.456,11.456,0,1,1,21.83-4.872,11.641,11.641,0,0,1-.059,1.165A11.472,11.472,0,0,1,582.222,261.639Z",
    transform: "translate(-562.208 -230.313)",
    fill: "#fff",
    opacity: 0.56
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10688",
    "data-name": "Group 10688",
    transform: "translate(89.689 327.287)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10682",
    "data-name": "Group 10682",
    transform: "translate(39.622 89.169)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1631",
    "data-name": "Rectangle 1631",
    width: 4.27,
    height: 48.138,
    transform: "translate(23.639 10.997)",
    fill: "url(#linear-gradient-20)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2955",
    "data-name": "Path 2955",
    d: "M171.668,754.87h37.4V753.6a1.627,1.627,0,0,0-1.627-1.626H173.421a1.753,1.753,0,0,0-1.753,1.753Z",
    transform: "translate(-164.595 -694.806)",
    fill: "url(#linear-gradient-21)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1632",
    "data-name": "Rectangle 1632",
    width: 49.979,
    height: 14.174,
    rx: 7.087,
    fill: "url(#linear-gradient-22)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10684",
    "data-name": "Group 10684",
    transform: "translate(24.543)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2956",
    "data-name": "Path 2956",
    d: "M266.925,726.551s13.806,5.947,13.015,12.169c0,0-14.271-2.737-16.825-6.816s-1.147-6.442-1.147-6.442Z",
    transform: "translate(-188.215 -594.227)",
    fill: "url(#linear-gradient-23)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2957",
    "data-name": "Path 2957",
    d: "M264.486,715.441l-.7,6.059a2,2,0,0,0,1.268,2.128,5.225,5.225,0,0,0,1.749.267,2.333,2.333,0,0,0,2.267-1.7l1.359-4.9Z",
    transform: "translate(-189.157 -589.914)",
    fill: "url(#linear-gradient-24)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2958",
    "data-name": "Path 2958",
    d: "M210.105,633.814s25.393-1.175,38.028,6.193-.641,42.734-.641,42.734-3.3.71-8.053-1.83c0,0,6.783-25.889-5-30.393-13.245-5.064-26.945-3.832-26.945-3.832l2.538-12.073Z",
    transform: "translate(-164.936 -554.752)",
    fill: "url(#linear-gradient-25)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2959",
    "data-name": "Path 2959",
    d: "M276.892,740.821c-2.887-.633-11.45-4.18-12.75-4.133s-3.143,2-3.143,2a3.463,3.463,0,0,0,.613,2.594c2.207,1.72,6.959,4.879,12.484,5.225A9.269,9.269,0,0,0,282,743.571,11.313,11.313,0,0,0,276.892,740.821Z",
    transform: "translate(-187.942 -599.059)",
    fill: "url(#linear-gradient-26)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2960",
    "data-name": "Path 2960",
    d: "M274.6,749.972c-5.525-.346-10.277-3.5-12.484-5.225a10.779,10.779,0,0,0,4.078,3.55c5.583,3.155,14.812,2.695,16.641,1.985,1.466-.569,1.013-1.938-.326-3.242A9.269,9.269,0,0,1,274.6,749.972Z",
    transform: "translate(-188.444 -602.528)",
    fill: "url(#linear-gradient-27)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2961",
    "data-name": "Path 2961",
    d: "M255.716,732.175c.189.715,2.212,2.863,3.381,4.06a2.3,2.3,0,0,0,2.139.644,5.922,5.922,0,0,0,1.531-.537,1.493,1.493,0,0,0,.578-2.031l-2.957-5.378Z",
    transform: "translate(-185.691 -595.721)",
    fill: "url(#linear-gradient-28)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2962",
    "data-name": "Path 2962",
    d: "M167.616,630.127s-2.217,15.724,4.192,18.938,20.466,5.318,25.306,13.474,13.538,24.163,21.45,28.763c0,0,4.519-1.47,5.84-3.693,0,0-9.393-24.691-13.311-30.693-3.394-5.2-8.356-12.685-15.405-15.924-2.018-.927-2.176-3.068-1.821-5.26l.647-3.992Z",
    transform: "translate(-147.612 -553.194)",
    fill: "url(#linear-gradient-29)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2963",
    "data-name": "Path 2963",
    d: "M251.966,581.2c-8.985,2.565-13.006-22.722-12.97-23.337L225.22,573.969s8.208,14.443,20.6,15.98a14.632,14.632,0,0,0,8.04-1.178A12.882,12.882,0,0,1,251.966,581.2Z",
    transform: "translate(-172.565 -522.091)",
    fill: "url(#linear-gradient-30)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2964",
    "data-name": "Path 2964",
    d: "M288.8,583.961c-3.916-1.609-7.238,1.6-7.238,1.6-3.881,3.972-6.958,5.977-9.4,6.675a12.882,12.882,0,0,0,1.9,7.572c4.841-2.218,7.663-6.7,8.825-8.939a1.682,1.682,0,0,1,2.217-.751c.83.4,1.685,1.014,1.739,1.846.106,1.64,2.057,1.737,2.069,1.131a24.353,24.353,0,0,0-1.512-3.845s4.5,2.886,6.251,3.99,3.243-.718,3.243-.718S292.714,585.571,288.8,583.961Z",
    transform: "translate(-192.758 -533.13)",
    fill: "url(#linear-gradient-31)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2965",
    "data-name": "Path 2965",
    d: "M170.01,537.879s12.074-8.238,41.235,6.66c0,0,3,3.807,1.6,8.1s-18.72,27.518-19.393,38.421c0,0-11.836,6.967-27.2.06C166.248,591.118,161.1,562.327,170.01,537.879Z",
    transform: "translate(-146.546 -512.512)",
    fill: "url(#linear-gradient-32)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2966",
    "data-name": "Path 2966",
    d: "M214.284,521.106l-4.771,9.35a2.659,2.659,0,0,0,.275,2.866c1.314,1.646,4.057,3.859,8.738,2.433a4.1,4.1,0,0,0,2.794-2.973l2.474-10.437Z",
    transform: "translate(-165.677 -506.271)",
    fill: "url(#linear-gradient-33)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2967",
    "data-name": "Path 2967",
    d: "M147.3,572.244c-.817-5.683,14.2-16.7,14.2-16.7l-5.26-15.949s-28.659,20.452-22.632,37.154a11.673,11.673,0,0,0,3.724,5.375C140.368,575.9,144.484,573.313,147.3,572.244Z",
    transform: "translate(-132.777 -514.229)",
    fill: "url(#linear-gradient-34)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2968",
    "data-name": "Path 2968",
    d: "M171.7,598.491s-16.989,4.745-20.514-.427a2.7,2.7,0,0,1-.439-1.151c-2.816,1.069-6.932,3.656-9.967,9.88,8.067,6.346,23.619-.768,27.845-2.9a2.985,2.985,0,0,1,2.238-.187,20.392,20.392,0,0,0,5.558,1.118c2.123-.117,4.4,7.555,8.015,5.613C184.433,610.437,182.791,597.33,171.7,598.491Z",
    transform: "translate(-136.22 -538.899)",
    fill: "url(#linear-gradient-35)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10683",
    "data-name": "Group 10683",
    transform: "translate(46.554)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2969",
    "data-name": "Path 2969",
    d: "M236.406,507.888c0,.253-5.655,16.007-5.655,16.007l-8.927-3.42,3.141-15.728S236.406,503.65,236.406,507.888Z",
    transform: "translate(-217.657 -499.176)",
    fill: "url(#linear-gradient-36)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2970",
    "data-name": "Path 2970",
    d: "M223.62,504.466l-2.3,8.15a1.159,1.159,0,0,0-.045.318c0,.665.163,2.952,2.494,2.641,2.114-.282,4.048-.508,5.277.071a1.182,1.182,0,0,1,.61,1.47,51.119,51.119,0,0,1-3.215,7.257,1.18,1.18,0,0,1-1.517.486,38.118,38.118,0,0,1-7.654-4.5,1.185,1.185,0,0,1-.419-1.136c.391-2.085,1.557-8.426,1.608-10.243.048-1.706-1.865-3.008-2.708-3.5a1.165,1.165,0,0,1-.548-.735c-.264-1.1-.489-3.583,2.681-4.13a1.184,1.184,0,0,0,.961-1.409,3.072,3.072,0,0,1,2.311-3.956,4.333,4.333,0,0,1,4.94,1.972,1.184,1.184,0,0,0,1.467.391.935.935,0,0,1,1.049.188,1.165,1.165,0,0,0,1.7-.259,3.532,3.532,0,0,1,4.355-1.438c4.033,1.3,3.84,5.955,2.361,8.482s-5.771.865-7.8-.81c-1.545-1.274-3.9-.512-4.936-.073A1.171,1.171,0,0,0,223.62,504.466Z",
    transform: "translate(-214.747 -495.061)",
    fill: "url(#linear-gradient-37)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2971",
    "data-name": "Path 2971",
    d: "M217.861,519.731s1.936-4.573.358-5.99-3.78-.931-3.708,2.6C214.6,520.731,217.861,519.731,217.861,519.731Z",
    transform: "translate(-214.509 -502.782)",
    fill: "url(#linear-gradient-38)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10685",
    "data-name": "Group 10685",
    transform: "translate(80.025 34.373)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2972",
    "data-name": "Path 2972",
    d: "M231.871,615.958l.091,0,39.69-.043a1.777,1.777,0,0,0,0-3.553l-39.69.043a1.777,1.777,0,0,0-.087,3.551Z",
    transform: "translate(-230.183 -579.921)",
    fill: "url(#linear-gradient-39)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2973",
    "data-name": "Path 2973",
    d: "M324.8,555.407H291.744a6.3,6.3,0,0,0-5.7,3.613l-15.281,32.4h41.078A3.828,3.828,0,0,0,315.4,589l11.85-29.983A2.64,2.64,0,0,0,324.8,555.407Z",
    transform: "translate(-247.65 -555.407)",
    fill: "url(#linear-gradient-40)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2974",
    "data-name": "Path 2974",
    d: "M324.5,582.073c-.716,2.225-.187,4.386,1.182,4.827s3.06-1.007,3.776-3.231.187-4.387-1.181-4.828S325.219,579.848,324.5,582.073Z",
    transform: "translate(-270.641 -565.459)",
    fill: "url(#linear-gradient-41)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10687",
    "data-name": "Group 10687",
    transform: "translate(0 70.032)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10686",
    "data-name": "Group 10686",
    transform: "translate(2.464 3.646)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2975",
    "data-name": "Path 2975",
    d: "M328.527,699.968a1.836,1.836,0,0,0,.658-.122,1.432,1.432,0,0,0,.873-1.955l-34.979-72.576a1.749,1.749,0,0,0-2.191-.779,1.433,1.433,0,0,0-.873,1.955l34.98,72.576A1.685,1.685,0,0,0,328.527,699.968Z",
    transform: "translate(-179.176 -624.414)",
    fill: "url(#linear-gradient-42)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2976",
    "data-name": "Path 2976",
    d: "M285.777,699.968a1.686,1.686,0,0,0,1.533-.9l34.979-72.576a1.433,1.433,0,0,0-.873-1.955,1.75,1.75,0,0,0-2.191.779L284.246,697.89a1.433,1.433,0,0,0,.873,1.955A1.834,1.834,0,0,0,285.777,699.968Z",
    transform: "translate(-175.833 -624.414)",
    fill: "url(#linear-gradient-43)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2977",
    "data-name": "Path 2977",
    d: "M138.432,699.968a1.831,1.831,0,0,0,.658-.122,1.433,1.433,0,0,0,.873-1.955l-34.979-72.576a1.749,1.749,0,0,0-2.191-.779,1.433,1.433,0,0,0-.873,1.955L136.9,699.067A1.687,1.687,0,0,0,138.432,699.968Z",
    transform: "translate(-97.358 -624.414)",
    fill: "url(#linear-gradient-44)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2978",
    "data-name": "Path 2978",
    d: "M95.683,699.968a1.686,1.686,0,0,0,1.533-.9l34.979-72.576a1.433,1.433,0,0,0-.873-1.955,1.75,1.75,0,0,0-2.192.779L94.151,697.89a1.433,1.433,0,0,0,.873,1.955A1.832,1.832,0,0,0,95.683,699.968Z",
    transform: "translate(-94.015 -624.414)",
    fill: "url(#linear-gradient-45)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2979",
    "data-name": "Path 2979",
    d: "M89.717,620.165a2.014,2.014,0,0,1,.332-1.5,1.5,1.5,0,0,1,1.214-.658H250.395a1.768,1.768,0,0,1,1.526.96,2.357,2.357,0,0,1,.118,2l-1.724,4.292a2.418,2.418,0,0,1-2.192,1.612H92.355a1.916,1.916,0,0,1-1.795-1.7Z",
    transform: "translate(-89.689 -618.012)",
    fill: "url(#linear-gradient-46)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10697",
    "data-name": "Group 10697",
    transform: "translate(405.191 197.277)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10693",
    "data-name": "Group 10693",
    transform: "translate(57.656 34.493)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2986",
    "data-name": "Path 2986",
    d: "M744.819,361.134l3.07,3.027a22.03,22.03,0,0,0,10.3-3.5,24.305,24.305,0,0,0-4.368-7.493A25.269,25.269,0,0,1,744.819,361.134Z",
    transform: "translate(-744.819 -338.475)",
    fill: "url(#linear-gradient-47)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2987",
    "data-name": "Path 2987",
    d: "M772.991,338.7l-7.246-11.329a28.562,28.562,0,0,1-5.125,14.7,24.306,24.306,0,0,1,4.368,7.493A19.934,19.934,0,0,0,772.991,338.7Z",
    transform: "translate(-751.619 -327.369)",
    fill: "url(#linear-gradient-48)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2988",
    "data-name": "Path 2988",
    d: "M788.732,499.666c-3.612.166-7.109.062-9.444-.058,2.126-1.513,7.023-4.805,11.121-6.116l2.813-.168a11.453,11.453,0,0,1,1.294,4.767C794.05,498.673,792.687,499.484,788.732,499.666Z",
    transform: "translate(-701.999 -364.304)",
    fill: "url(#linear-gradient-49)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2989",
    "data-name": "Path 2989",
    d: "M779.079,503.23l.03-.02c2.335.12,5.831.224,9.444.058,3.955-.182,5.318-.993,5.784-1.575.016.153.032.3.045.465a1.316,1.316,0,0,1-1.21,1.422c-2.959.224-10.295.731-13.832.545A.494.494,0,0,1,779.079,503.23Z",
    transform: "translate(-701.819 -367.906)",
    fill: "url(#linear-gradient-50)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2990",
    "data-name": "Path 2990",
    d: "M841.218,498.823a27.27,27.27,0,0,1,1.017-4.775c.514-.983,2.274,0,2.274,0a4.674,4.674,0,0,1,1.8,1.537c.363.612,1.365,2.354,2.045,3.537a.8.8,0,0,1,.106.421l-7.049.247A1.408,1.408,0,0,1,841.218,498.823Z",
    transform: "translate(-728.646 -364.427)",
    fill: "url(#linear-gradient-51)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2991",
    "data-name": "Path 2991",
    d: "M848.628,504.025a.8.8,0,0,1-.781.78l-5.022.138a1.417,1.417,0,0,1-1.246-.672Z",
    transform: "translate(-728.809 -368.909)",
    fill: "url(#linear-gradient-52)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2992",
    "data-name": "Path 2992",
    d: "M840.286,483.817c.06.2.971,4.619,1.37,6.557a1.107,1.107,0,0,0,1.139.885c.3-.015.645-.042,1.009-.089a1.337,1.337,0,0,0,1.162-1.274c.064-1.7.1-4.957-.527-6.219C843.579,481.934,840.286,483.817,840.286,483.817Z",
    transform: "translate(-728.252 -359.833)",
    fill: "url(#linear-gradient-53)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2993",
    "data-name": "Path 2993",
    d: "M801.755,485.64c-.391-.012.155,2.017-.435,4.012a1.026,1.026,0,0,1-.939.809c-.3,0-.664,0-1.03-.031a1.133,1.133,0,0,1-1.044-1.021l-.48-5.174Z",
    transform: "translate(-709.978 -360.392)",
    fill: "url(#linear-gradient-54)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2994",
    "data-name": "Path 2994",
    d: "M785.539,388.251c.174.849,6.329,36.745,6.7,55.32a.632.632,0,0,0,.544.616,12.427,12.427,0,0,0,3.777-.025.446.446,0,0,0,.367-.409c.215-3.461,1.945-32.728-.174-46.505,0,0,17.5,36.828,20.151,46.983a.533.533,0,0,0,.546.4A13.2,13.2,0,0,0,821,444a.926.926,0,0,0,.584-1.089c-1.481-6.077-11.867-47.948-18.919-57.173Z",
    transform: "translate(-704.689 -317.998)",
    fill: "url(#linear-gradient-55)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2995",
    "data-name": "Path 2995",
    d: "M803.289,404.19a.229.229,0,0,0,.164-.39l-2.343-2.4a.23.23,0,1,0-.329.321l2.343,2.4A.227.227,0,0,0,803.289,404.19Z",
    transform: "translate(-711.221 -324.711)",
    fill: "url(#linear-gradient-56)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2996",
    "data-name": "Path 2996",
    d: "M766.532,309.22c4.495-1.177,12.786-3.022,19.386-2.628a2.988,2.988,0,0,1,2.817,2.805c1,17.578,2.359,33.177,4.925,42.253-5.767,2.282-11.485,3.341-17.125,2.512A189.461,189.461,0,0,1,765.458,322.8s-1.852-9.465-.054-12.62A1.86,1.86,0,0,1,766.532,309.22Z",
    transform: "translate(-695.685 -283.91)",
    fill: "url(#linear-gradient-57)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2997",
    "data-name": "Path 2997",
    d: "M781.864,289.628s1.135,6.771,1.474,9.9a1.226,1.226,0,0,1-.666,1.224,8.961,8.961,0,0,1-6.774.723,1.145,1.145,0,0,1-.776-1.115l.2-9.039Z",
    transform: "translate(-700.205 -276.632)",
    fill: "url(#linear-gradient-58)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10694",
    "data-name": "Group 10694",
    transform: "translate(71.419)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2998",
    "data-name": "Path 2998",
    d: "M772.093,276.457s-2.19,5.031-2.337,7.671-.716,4.354,2.337,4.885a6.489,6.489,0,0,0,7.018-3.619s2.183-4.053,1.693-5.712S772.093,276.457,772.093,276.457Z",
    transform: "translate(-769.255 -270.963)",
    fill: "url(#linear-gradient-59)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2999",
    "data-name": "Path 2999",
    d: "M777.794,279.351h-.386s1.59-3.262.193-3.835-6.932-1.7-8.126-3.666a3.652,3.652,0,0,1,1.411-5.023.206.206,0,0,1,.262.1l.127.241a.207.207,0,0,0,.382-.039h0a.207.207,0,0,1,.372-.057c.366.587,1.356,1.542,4.01,2.032,3.767.7,6.258,2.22,6.319,4.823a.207.207,0,0,0,.321.17c.278-.169.723-.249,1.318.251,1.034.87.611,3.126-1.656,4.982a.206.206,0,0,0,.01.333c.411.268,1.024.9-.564,1.753a4.233,4.233,0,0,1-2.948.681.208.208,0,0,1-.157-.215l.143-2.307a.208.208,0,0,0-.207-.22Z",
    transform: "translate(-768.982 -266.811)",
    fill: "url(#linear-gradient-60)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3000",
    "data-name": "Path 3000",
    d: "M784.286,287.807s.836-3.214,2.277-2.312-.748,3.6-1.907,3.721Z",
    transform: "translate(-775.569 -274.784)",
    fill: "url(#linear-gradient-61)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10695",
    "data-name": "Group 10695",
    transform: "translate(0 25.145)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3001",
    "data-name": "Path 3001",
    d: "M796.652,367.338l-88.639-18.377-2.24,8.863L792.5,383.774c.194.057.388.112.584.161l2.957.747c5.075,1.283,9.891-.451,10.756-3.873l1.028-4.068c.865-3.422-2.548-7.236-7.623-8.519l-2.958-.748C797.047,367.425,796.85,367.379,796.652,367.338Zm5.2,10.056c-.574,2.27-4.136,3.328-7.957,2.362s-6.454-3.59-5.88-5.86,4.137-3.328,7.958-2.362S802.422,375.124,801.848,377.395Z",
    transform: "translate(-670.357 -327.314)",
    fill: "#125082"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3002",
    "data-name": "Path 3002",
    d: "M652.726,320.561l17.161,4.338a4.06,4.06,0,0,1,2.732,2.324l2.568,5.928a4.062,4.062,0,0,1-1.215,4.806l-5.076,4a4.064,4.064,0,0,1-3.508.746l-17.161-4.337a3.122,3.122,0,0,0-3.566,4.421,23.363,23.363,0,0,0,15.116,11.9c12.341,3.12,23.263-4.357,26.264-16.228s-3.057-23.64-15.4-26.76a23.362,23.362,0,0,0-18.953,3.285A3.122,3.122,0,0,0,652.726,320.561Z",
    transform: "translate(-643.905 -310.957)",
    fill: "url(#linear-gradient-62)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3003",
    "data-name": "Path 3003",
    d: "M652.008,323.4l17.161,4.338a4.063,4.063,0,0,1,2.732,2.324l2.568,5.928a4.061,4.061,0,0,1-1.215,4.806l-5.076,4a4.062,4.062,0,0,1-3.508.747L647.509,341.2a3.122,3.122,0,0,0-3.566,4.421,23.363,23.363,0,0,0,15.116,11.9c12.341,3.12,23.263-4.358,26.264-16.229s-3.056-23.64-15.4-26.759a23.363,23.363,0,0,0-18.954,3.284A3.122,3.122,0,0,0,652.008,323.4Z",
    transform: "translate(-643.596 -312.179)",
    fill: "url(#linear-gradient-63)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3004",
    "data-name": "Path 3004",
    d: "M796.079,369.6l-88.638-18.377-2.241,8.863,86.725,25.949q.29.086.584.161l2.958.747c5.075,1.283,9.89-.451,10.755-3.873l1.029-4.068c.865-3.422-2.548-7.236-7.623-8.519l-2.957-.748Q796.376,369.665,796.079,369.6Zm5.2,10.056c-.574,2.27-4.137,3.328-7.958,2.362s-6.454-3.59-5.879-5.86,4.136-3.328,7.958-2.362S801.849,377.389,801.276,379.66Z",
    transform: "translate(-670.111 -328.289)",
    fill: "url(#linear-gradient-64)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10696",
    "data-name": "Group 10696",
    transform: "translate(90.921 22.95)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3005",
    "data-name": "Path 3005",
    d: "M827.378,351.653a28.057,28.057,0,0,1,.971,12.922l2.93.781s3.785-4.5,2.919-14.492A14.294,14.294,0,0,0,827.378,351.653Z",
    transform: "translate(-813.617 -325.881)",
    fill: "url(#linear-gradient-65)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3006",
    "data-name": "Path 3006",
    d: "M823.8,332.087c-.1-1.123-.251-2.313-.477-3.576-1.98-11.018-16.105-19.494-19.429-21.35a.454.454,0,0,0-.674.414l.472,14.978c7.867,1.058,11.59,5.559,13.288,10.322A14.292,14.292,0,0,1,823.8,332.087Z",
    transform: "translate(-803.22 -307.103)",
    fill: "url(#linear-gradient-66)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3007",
    "data-name": "Path 3007",
    d: "M732.648,373.553a1.9,1.9,0,0,1-1.227-1.062c-.45-1.008-.957-2.622.125-3.115,1.611-.733,4.541,2.271,4.541,2.271l1.432,2.32,1.309.637C737.629,374.934,735.316,374.384,732.648,373.553Z",
    transform: "translate(-681.172 -310.906)",
    fill: "url(#linear-gradient-67)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3008",
    "data-name": "Path 3008",
    d: "M826.689,372.464h-3.622s2.939,1.762,3.036,3.616a18.64,18.64,0,0,1-1.758,6.738c-.647,1.143,8.2-1.7,5.078-10.353Z",
    transform: "translate(-720.841 -312.285)",
    fill: "url(#linear-gradient-68)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrowyourBusinesssection);
export default __webpack_public_path__ + "static/media/Grow your Business section.6d7c1a4dd6486129f0778bc868733daf.svg";
export { ForwardRef as ReactComponent };